// packages/shared-utils/src/main/supportedDevices.data.ts
import { SDK_KEYBOARD_MOUSE_TYPE } from "./supportedDevicesConstants";

/**
 * 设备配置表（独立 chunk，由 supportedDevicesStore 按需加载）
 *
 * `displayname` 为业务标识（存储 / 匹配 / 配色键），界面展示文案请走 UI 映射：
 * - 映射实现：packages/shared-utils/src/main/formatDeviceDisplayLabel.ts
 * - 规范文档：docs/设备展示名-UI映射规范.md
 */
export const SUPPORTED_DEVICES = {
  keyboard: [
    {
      vendorId: 0x1ca6,
      productId: 0x1c0a,
      productName: "X87",
      displayname: "X87 HE",
      keyboardType: "87",
      solutionRovider: "xingshan",

      uniqueNumber: "1",
      adaptation: [],
      isSupported: true,
    },
    {
      vendorId: 0x1ca6, // 7334
      productId: 0x1c3e, // 7230
      productName: "EWEADN ES87",
      displayname: "Alpha 87",
      keyboardType: "es87",
      solutionRovider: "xingshan",

      uniqueNumber: "3",
      adaptation: [],
      isSupported: true,
      brand: "EXX",
    },
    {
      vendorId: 0x1ca6, // 7334
      productId: 0x1c3e, // 7230
      productName: "EXX Alpha 87",
      displayname: "Alpha 87",
      keyboardType: "es87",
      solutionRovider: "xingshan",

      uniqueNumber: "3",
      adaptation: [],
      isSupported: true,
      brand: "EXX",
    },
    {
      vendorId: 0x1ca6,
      productId: 0x1c14,
      productName: "DEEP68 PRO",
      displayname: "DEEP68 Pro",
      keyboardType: "68",
      solutionRovider: "xingshan",

      uniqueNumber: "4",
      adaptation: [],
      isSupported: true,
    },
    {
      vendorId: 0x1ca6, // 7334
      productId: 0x1c12, // 7186
      productName: "EWEADN-DK68",
      displayname: "DK68",
      keyboardType: "68",
      solutionRovider: "xingshan",

      uniqueNumber: "5",
      adaptation: [],
      isSupported: true,
    },
    {
      vendorId: 0x1ca6, // 7334
      productId: 0x1c1f, // 7199
      productName: "EWEADN-DK68",
      displayname: "DK68",
      keyboardType: "68",
      solutionRovider: "xingshan",

      uniqueNumber: "6",
      adaptation: [],
      isSupported: true,
    },
    {
      vendorId: 0x1ca6,
      productId: 0x1c2b,
      productName: "EWEADN-DK68 Star",
      displayname: "DK68 Star",
      keyboardType: "68",
      solutionRovider: "xingshan",

      uniqueNumber: "8",
      adaptation: [],
      isSupported: true,
    },
    {
      vendorId: 0x1ca6,
      productId: 0x1c2b,
      productName: "EWEADN-DK63 Star",
      displayname: "DK63 Star",
      keyboardType: "68",
      solutionRovider: "xingshan",

      uniqueNumber: "13",
      adaptation: [],
      isSupported: true,
    },
    {
      vendorId: 0x1ca6, // 7334
      productId: 0x1c3c, // 7228
      productName: "DK68 V2",
      displayname: "DK68 V2",
      keyboardType: "68",
      solutionRovider: "xingshan",

      uniqueNumber: "9",
      adaptation: [],
      isSupported: true,
    },
    {
      vendorId: 0x1ca6, // 7334
      productId: 0x1c1a, // 7194
      productName: "DK68 V2",
      displayname: "DK68 V2",
      keyboardType: "68",
      solutionRovider: "xingshan",

      uniqueNumber: "10",
      adaptation: [],
      isSupported: true,
    },
    {
      vendorId: 0x1ca6, // 7334
      productId: 0x1c3d, // 7229
      productName: "DK80",
      displayname: "DK80",
      keyboardType: "deep80max",
      solutionRovider: "xingshan",

      uniqueNumber: "14",
      adaptation: [],
      isSupported: true,
    },
    {
      vendorId: 0x1ca6, // 7334
      productId: 0x1c23, // 7203
      productName: "EWEADN DK68 Pro",
      displayname: "DK68 Pro", //下灯位 035
      keyboardType: "68",
      solutionRovider: "xingshan",

      uniqueNumber: "7",
      adaptation: [],
      isSupported: true,
    },
    {
      vendorId: 0x1ca6, // 7334
      productId: 0x1c2c, // 7212
      productName: "EWEADN DK68 Pro",
      displayname: "DK68-Pro", //上灯位 044
      keyboardType: "68",
      solutionRovider: "xingshan",

      uniqueNumber: "11",
      adaptation: [],
      isSupported: true,
    },
    {
      vendorId: 0x1ca6,
      productId: 0x1c24,
      productName: "EWEADN ES68 Dawn",
      displayname: "ES68",
      keyboardType: "68",
      solutionRovider: "xingshan",

      uniqueNumber: "15",
      adaptation: [],
      isSupported: true,
      demoEnable: true,
    },
    {
      vendorId: 0x1ca6, // 7334
      productId: 0x1c50, // 7248，ES68 Lite 洛天依联名 es68-luotianyi 固件 v1
      /** 实机 HID productName 为 ES68；展示/能力按 Lite（displayname） */
      productName: "ES68 TIANYI",
      displayname: "ES68 TIANYI",
      keyboardType: "68",
      solutionRovider: "xingshan",
      uniqueNumber: "31",
      adaptation: [],
      isSupported: true,
      // 预设壁纸授权商 ID: 洛天依（进子应用同 VX07 耳机，默认切第一张洛天依壁纸）
      licensorId: 1,
    },
    {
      vendorId: 0x1a86,
      productId: 0xfe81,
      productName: "EWEADN ES68 Dawn",
      displayname: "ES68",
      keyboardType: "68",
      solutionRovider: "xingshan",

      uniqueNumber: "16",
      adaptation: [],
      isSupported: true,
    },
    {
      vendorId: 0x1ca6,
      productId: 0x1c2f,
      productName: "EWEADN ES68 EVO",
      displayname: "ES68 EVO",
      keyboardType: "68EVO",
      solutionRovider: "xingshan",

      uniqueNumber: "17",
      adaptation: [],
      isSupported: true,
    },
    {
      vendorId: 0x1a86,
      productId: 0xfe81,
      productName: "EWEADN ES68 EVO",
      displayname: "ES68 EVO",
      keyboardType: "68EVO",
      solutionRovider: "xingshan",

      uniqueNumber: "18",
      adaptation: [],
      isSupported: true,
    },
    {
      vendorId: 0x1ca6,
      productId: 0x1c4a,
      productName: "ES68 Lite",
      displayname: "ES68 Lite",
      keyboardType: "68",
      solutionRovider: "xingshan",

      uniqueNumber: "20",
      adaptation: [],
      isSupported: true,
    },
    {
      vendorId: 0x1ca6,
      productId: 0x1c4c,
      productName: "EWEADN ES68 EVO",
      displayname: "ES68 EVO (Full)",
      keyboardType: "68",
      solutionRovider: "xingshan",

      uniqueNumber: "19",
      adaptation: [],
      isSupported: true,
    },
    {
      vendorId: 0x1ca6,
      productId: 0x5e01,
      productName: "DK63",
      displayname: "DK63",
      keyboardType: "63",
      solutionRovider: "xingshan",

      uniqueNumber: "12",
      adaptation: [],
      isSupported: true,
    },
    {
      vendorId: 0x1ca6, // 7334
      productId: 0x1c4d, // 7245 — 单灯位
      productName: "EWEADN-DK63V2",
      displayname: "DK63 V2",
      keyboardType: "63",
      solutionRovider: "xingshan",
      uniqueNumber: "32",
      adaptation: [],
      isSupported: true,
    },
    {
      vendorId: 0x1ca6, // 7334
      productId: 0x1c49, // 7241 — 双灯位（DoubleLighting / 上灯 / 下灯，同 Gamma75）
      productName: "EWEADN-DK63V2",
      displayname: "DK63 V2",
      keyboardType: "63",
      solutionRovider: "xingshan",
      uniqueNumber: "33",
      adaptation: [],
      isSupported: true,
      hasDoubleLighting: true,
    },
    {
      vendorId: 0x1ca6,
      productId: 0x2709,
      productName: "EWEADN DK75",
      displayname: "DK75 Pro",
      keyboardType: "dk75Pro",
      solutionRovider: "xingshan",

      uniqueNumber: "23",
      adaptation: [],
      isSupported: true,
      /** 双灯位 / 点阵屏能力见 hasDoubleLighting、hasDotMatrixScreen */
      hasDoubleLighting: true,
      hasDotMatrixScreen: true,
    },
    {
      vendorId: 0x1ca6,
      productId: 0x2708,
      productName: "DK75",
      displayname: "DK75 E",
      keyboardType: "dk75E",
      solutionRovider: "xingshan",

      uniqueNumber: "22",
      adaptation: [],
      isSupported: true,
    },
    {
      vendorId: 0x1ca6,
      productId: 0x270a,
      productName: "EWEADN DK75",
      displayname: "DK75",
      keyboardType: "dk75",
      solutionRovider: "xingshan",

      uniqueNumber: "21",
      adaptation: [],
      isSupported: true,
      hasDoubleLighting: true,
    },
    {
      vendorId: 0x258a,
      productId: 0x010c,
      productName: "Gaming Keyboard",
      displayname: "X75V2",
      keyboardType: "x75v2",
      solutionRovider: "beiying",

      uniqueNumber: "2",
      adaptation: [0x010c],
      uuid: [0x300000003e8],
      sdkType: SDK_KEYBOARD_MOUSE_TYPE.keyboard.beiyingMachine,
      machineBoard: "916",
      isSupported: true,
    },
    {
      vendorId: 0x3554, // 13652
      productId: 0xfa09, // 64009
      productName: "2.4G Wireless Receiver",
      is4G: true,
      displayname: "X75V2",
      keyboardType: "x75v2",
      solutionRovider: "beiying",

      uniqueNumber: "2-1",
      adaptation: [0xfa09],
      uuid: [0x300000003e8],
      sdkType: SDK_KEYBOARD_MOUSE_TYPE.keyboard.beiyingMachine,
      machineBoard: "916",
      isSupported: true,
    },
    {
      vendorId: 0x1ca6,
      productId: 0x1c2d,
      productName: "X75 V3",
      displayname: "X75 V3",
      keyboardType: "x75v3",
      solutionRovider: "xingshan",

      uniqueNumber: "25",
      adaptation: [],
      isSupported: false,
      brand: "EXX",
    },
    {
      vendorId: 0x1ca6,
      productId: 0x1c37,
      productName: "EXXGamma75",
      displayname: "Gamma75",
      keyboardType: "gamma75",
      solutionRovider: "xingshan",

      uniqueNumber: "27",
      adaptation: [],
      isSupported: true,
      brand: "EXX",
      demoEnable: true,
    },
    {
      vendorId: 0x1ca6,
      productId: 0x1c37,
      productName: "METAWAY Y75",
      displayname: "Gamma75",
      keyboardType: "gamma75",
      solutionRovider: "xingshan",

      uniqueNumber: "27",
      adaptation: [],
      isSupported: true,
      brand: "EXX",
    },
    {
      vendorId: 0x1ca6,
      productId: 0x1c4e,
      productName: "EXXGamma75 Pro",
      displayname: "Gamma75 Pro",
      keyboardType: "gamma75",
      solutionRovider: "xingshan",
      uniqueNumber: "34",
      adaptation: [],
      isSupported: true,
      brand: "EXX",
    },
    {
      vendorId: 0x1ca6,
      productId: 0x1c51,
      productName: "EXXGamma75 Pro",
      displayname: "Gamma75 Pro Evo",
      keyboardType: "gamma75",
      solutionRovider: "xingshan",
      uniqueNumber: "35",
      adaptation: [],
      isSupported: true,
      brand: "EXX",
    },
    {
      vendorId: 0x1ca6,
      productId: 0x1c45,
      productName: "EXXGamma75 Ultra",
      displayname: "Gamma75 Ultra",
      keyboardType: "gamma75",
      solutionRovider: "xingshan",
      uniqueNumber: "36",
      adaptation: [],
      isSupported: true,
      brand: "EXX",
      /** 双灯位（矩阵与单灯位 Gamma75 相同，灯效协议同 DK75） */
      hasDoubleLighting: true,
    },
    {
      vendorId: 0x0c45,
      productId: 0x8006,
      productName: "X87",
      displayname: "X87",
      identifier: "3141:32774:X87",
      workMode: "0", //工作模式：0 = USB，1 = 蓝牙（BT），2 = 2.4G 无线
      keyboardType: "huafenda87",
      solutionRovider: "huafenda",

      uniqueNumber: "1",
      adaptation: [0xff68, 0xff80, 0xff00, 0xff01, 0xff1b, 0xff59],
      adaptation1: [],
      adaptation24G: [],
      isSupported: true,
    },
    {
      vendorId: 0x0c45,
      productId: 0xfefe,
      productName: "2.4G Dongle",
      displayname: "X87",
      identifier: "3141:65278:2.4G Dongle:2:5",
      workMode: "2",
      keyboardType: "huafenda87",
      solutionRovider: "huafenda",

      uniqueNumber: "1-1",
      adaptation: [0xff68, 0xff80, 0xff00, 0xff01, 0xff1b, 0xff59],
      adaptation1: [0xff68, 0xff80, 0xff60, 0xff00, 0xff01, 0xff1b, 0xff59],
      adaptation24G: [0xff60],
      isSupported: true,
    },
    {
      vendorId: 0x0c45,
      productId: 0x80bb,
      productName: "X87 V2",
      displayname: "X87 V2",
      identifier: "3141:32955:X87 V2",
      workMode: "0", //工作模式：0 = USB，1 = 蓝牙（BT），2 = 2.4G 无线
      keyboardType: "huafenda87",
      solutionRovider: "huafenda",

      uniqueNumber: "2",
      adaptation: [0xff68, 0xff80, 0xff00, 0xff01, 0xff1b, 0xff59],
      adaptation1: [],
      adaptation24G: [],
      isSupported: true,
    },
    {
      vendorId: 0x0c45,
      productId: 0xfef9,
      productName: "X87 V2",
      displayname: "X87 V2",
      identifier: "3141:65273:2.4G Dongle",
      workMode: "2", // 2.4G 接收器；0 = USB，1 = 蓝牙（BT），2 = 2.4G 无线
      keyboardType: "huafenda87",
      solutionRovider: "huafenda",

      uniqueNumber: "2-1",
      adaptation: [0xff68, 0xff80, 0xff00, 0xff01, 0xff1b, 0xff59],
      adaptation1: [0xff68, 0xff80, 0xff60, 0xff00, 0xff01, 0xff1b, 0xff59],
      adaptation24G: [0xff60],
      isSupported: true,
      demoEnable: true,
    },
    {
      vendorId: 0x0c45,
      productId: 0x8802,
      productName: "X75GC",
      displayname: "X75GC",
      identifier: "3141:34818:X75GC",
      workMode: "0", //工作模式：0 = USB，1 = 蓝牙（BT），2 = 2.4G 无线
      keyboardType: "x75gc",
      solutionRovider: "huafenda",

      uniqueNumber: "6",
      adaptation: [0xff68, 0xff80, 0xff00, 0xff01, 0xff1b, 0xff59],
      adaptation1: [],
      adaptation24G: [],
      isSupported: true,
      hasScreen: true,
    },
    {
      vendorId: 0x0c45,
      productId: 0x8803,
      productName: "X75GC",
      displayname: "X75GC",
      identifier: "3141:34819:X75GC",
      workMode: "0", //工作模式：0 = USB，1 = 蓝牙（BT），2 = 2.4G 无线
      keyboardType: "x75gc",
      solutionRovider: "huafenda",
      adaptation: [0xff68, 0xff80, 0xff00, 0xff01, 0xff1b, 0xff59],
      adaptation1: [],
      adaptation24G: [],
      isSupported: true,
      hasScreen: true,
    },
    {
      vendorId: 0x0c45,
      productId: 0xfef9,
      productName: "X75GC",
      displayname: "X75GC",
      identifier: "3141:65273:X75GC",
      workMode: "2", // 2.4G 接收器；0 = USB，1 = 蓝牙（BT），2 = 2.4G 无线
      is4G: true,
      keyboardType: "x75gc",
      solutionRovider: "huafenda",

      uniqueNumber: "6-1",
      adaptation: [0xff68, 0xff80, 0xff00, 0xff01, 0xff1b, 0xff59],
      adaptation1: [0xff68, 0xff80, 0xff60, 0xff00, 0xff01, 0xff1b, 0xff59],
      adaptation24G: [0xff60],
      isSupported: true,
      hasScreen: true,
    },
    {
      vendorId: 0x0c45, // 3141
      productId: 0x8006, // 32774
      productName: "SMART875",
      displayname: "SMART875",
      identifier: "3141:32774:SMART875",
      workMode: "0",
      keyboardType: "84",
      solutionRovider: "huafenda",

      uniqueNumber: "7",
      adaptation: [0xff68, 0xff80, 0xff00, 0xff01, 0xff1b, 0xff59],
      adaptation1: [],
      adaptation24G: [],
      isSupported: true,
    },
    {
      vendorId: 0x0c45,
      productId: 0xfefe,
      productName: "2.4G Dongle",
      is4G: true,
      displayname: "SMART875",
      identifier: "3141:65278:SMART875",
      workMode: "2",
      keyboardType: "84",
      solutionRovider: "huafenda",

      uniqueNumber: "7-1",
      adaptation: [0xff68, 0xff80, 0xff00, 0xff01, 0xff1b, 0xff59],
      adaptation1: [0xff68, 0xff80, 0xff60, 0xff00, 0xff01, 0xff1b, 0xff59],
      adaptation24G: [0xff60],
      isSupported: true,
    },
    {
      vendorId: 0x0c45,
      productId: 0x8006,
      productName: "X75 Pro",
      displayname: "X75 Pro",
      identifier: "3141:32774:X75 Pro",
      workMode: "0",
      keyboardType: "75Pro",
      solutionRovider: "huafenda",

      uniqueNumber: "3",
      adaptation: [0xff68, 0xff80, 0xff00, 0xff01, 0xff1b, 0xff59],
      adaptation1: [],
      adaptation24G: [],
      isSupported: true,
    },
    {
      vendorId: 0x0c45,
      productId: 0xfefe,
      productName: "2.4G Dongle",
      is4G: true,
      displayname: "X75 Pro",
      identifier: "3141:65278:2.4G Dongle:2:2",
      workMode: "2",
      keyboardType: "75Pro",
      solutionRovider: "huafenda",

      uniqueNumber: "3-2",
      adaptation: [0xff68, 0xff80, 0xff00, 0xff01, 0xff1b, 0xff59],
      adaptation1: [0xff68, 0xff80, 0xff60, 0xff00, 0xff01, 0xff1b, 0xff59],
      adaptation24G: [0xff60],
      isSupported: true,
    },
    {
      vendorId: 0x0c45,
      productId: 0x80d2,
      productName: "EWEADN-X75Pro",
      displayname: "X75-Pro",
      identifier: "3141:32978:EWEADN-X75Pro",
      workMode: "0",
      keyboardType: "75Pro",
      solutionRovider: "huafenda",

      uniqueNumber: "5",
      adaptation: [0xff68, 0xff80, 0xff00, 0xff01, 0xff1b, 0xff59],
      adaptation1: [],
      adaptation24G: [],
      isSupported: true,
    },
    {
      vendorId: 0x0c45,
      productId: 0xfefa,
      productName: "2.4G Dongle",
      displayname: "X75-Pro",
      identifier: "3141:65274:2.4G Dongle:2:27",
      workMode: "2",
      keyboardType: "75Pro",
      solutionRovider: "huafenda",

      uniqueNumber: "5-1",
      adaptation: [0xff68, 0xff80, 0xff00, 0xff01, 0xff1b, 0xff59],
      adaptation1: [0xff68, 0xff80, 0xff60, 0xff00, 0xff01, 0xff1b, 0xff59],
      adaptation24G: [0xff60],
      isSupported: true,
    },
    {
      vendorId: 0x0c45,
      productId: 0xfefe,
      productName: "2.4G Dongle",
      is4G: true,
      displayname: "X75 Pro",
      identifier: "3141:65278:2.4G Dongle:2:2",
      workMode: "2",
      keyboardType: "75Pro",
      solutionRovider: "huafenda",

      uniqueNumber: "3-2",
      adaptation: [0xff68, 0xff80, 0xff00, 0xff01, 0xff1b, 0xff59],
      adaptation1: [0xff68, 0xff80, 0xff60, 0xff00, 0xff01, 0xff1b, 0xff59],
      adaptation24G: [0xff60],
      isSupported: true,
    },
    {
      vendorId: 0x0c45,
      productId: 0x8009,
      productName: "X75 Pro Screen",
      displayname: "X75 Pro Screen",
      identifier: "3141:32777:X75 Pro",
      workMode: "0",
      keyboardType: "75ProTFT",
      solutionRovider: "huafenda",

      uniqueNumber: "4",
      adaptation: [0xff68, 0xff80, 0xff00, 0xff01, 0xff1b, 0xff59],
      adaptation1: [],
      adaptation24G: [],
      isSupported: true,
      hasScreen: true,
    },
    {
      vendorId: 0x0c45,
      productId: 0xfefe,
      productName: "2.4G Dongle",
      is4G: true,
      displayname: "X75 Pro Screen",
      identifier: "3141:65278:2.4G Dongle:2:1",
      workMode: "2",
      keyboardType: "75ProTFT",
      solutionRovider: "huafenda",

      uniqueNumber: "4-1",
      adaptation: [0xff68, 0xff80, 0xff00, 0xff01, 0xff1b, 0xff59],
      adaptation1: [0xff68, 0xff80, 0xff60, 0xff00, 0xff01, 0xff1b, 0xff59],
      adaptation24G: [0xff60],
      isSupported: true,
      hasScreen: true,
    },
    {
      vendorId: 0x0c45,
      productId: 0x8006,
      productName: "M98",
      displayname: "M98",
      identifier: "3141:32774:MUSE-M98",
      workMode: "0",
      keyboardType: "M98",
      solutionRovider: "huafenda",

      uniqueNumber: "8",
      adaptation: [0xff68, 0xff80, 0xff00, 0xff01, 0xff1b, 0xff59],
      adaptation1: [],
      adaptation24G: [],
      isSupported: true,
    },
    {
      vendorId: 0x0c45,
      productId: 0xfefe,
      product: 1, //1、M98基础版 5、M98屏幕版
      productName: "MUSE-M98",
      is4G: true,
      displayname: "M98",
      identifier: "3141:65278:MUSE-M98",
      workMode: "2",
      keyboardType: "M98",
      solutionRovider: "huafenda",

      uniqueNumber: "8-1",
      adaptation: [0xff68, 0xff80, 0xff00, 0xff01, 0xff1b, 0xff59],
      adaptation1: [0xff68, 0xff80, 0xff60, 0xff00, 0xff01, 0xff1b, 0xff59],
      adaptation24G: [0xff60],
      isSupported: true,
    },
    // M98 屏幕版 有线
    {
      vendorId: 0x0c45,
      productId: 0x2711,
      productName: "MUSE-M98",
      displayname: "M98 Screen",
      identifier: "3141:10001:MUSE-M98",
      workMode: "0",
      keyboardType: "M98TFT",
      solutionRovider: "huafenda",

      uniqueNumber: "10",
      adaptation: [0xff68, 0xff80, 0xff00, 0xff01, 0xff1b, 0xff59],
      adaptation1: [],
      adaptation24G: [],
      isSupported: true,
      hasScreen: true,
    },
    // M98 屏幕版 无线
    {
      vendorId: 0x0c45,
      productId: 0xfefe,
      product: 5, //1、M98基础版 5、M98屏幕版
      productName: "MUSE-M98",
      displayname: "M98 Screen",
      identifier: "3141:65278:MUSE-M98",
      workMode: "2",
      keyboardType: "M98TFT",
      solutionRovider: "huafenda",

      uniqueNumber: "10-1",
      adaptation: [0xff68, 0xff80, 0xff00, 0xff01, 0xff1b, 0xff59],
      adaptation1: [0xff68, 0xff80, 0xff60, 0xff00, 0xff01, 0xff1b, 0xff59],
      adaptation24G: [0xff60],
      isSupported: true,
      hasScreen: true,
    },
    // M98 8K 有线
    {
      vendorId: 0x0c45,
      productId: 0x8803,
      productName: "MUSE-M98",
      displayname: "M98 (8K)",
      identifier: "3141:34819:MUSE-M98",
      workMode: "0",
      keyboardType: "M98 8K",
      solutionRovider: "huafenda",

      uniqueNumber: "9",
      adaptation: [0xff68, 0xff80, 0xff00, 0xff01, 0xff1b, 0xff59],
      adaptation1: [],
      adaptation24G: [],
      isSupported: true,
      hasScreen: true,
    },
    // M98 8K 无线
    {
      vendorId: 0x0c45,
      productId: 0xfefc,
      productName: "MUSE-M98-8K",
      displayname: "M98 (8K)",
      identifier: "3141:65276:MUSE-M98-8K",
      workMode: "2",
      keyboardType: "M98 8K",
      solutionRovider: "huafenda",

      uniqueNumber: "9-1",
      adaptation: [0xff68, 0xff80, 0xff00, 0xff01, 0xff1b, 0xff59],
      adaptation1: [0xff68, 0xff80, 0xff60, 0xff00, 0xff01, 0xff1b, 0xff59],
      adaptation24G: [0xff60],
      isSupported: true,
      hasScreen: true,
    },
    {
      vendorId: 0x0c45,
      productId: 0x80b2,
      productName: "X98",
      displayname: "X98 (1K)",
      identifier: "3141:32946:X98",
      workMode: "0",
      keyboardType: "huafenda98",
      solutionRovider: "huafenda",

      uniqueNumber: "11",
      adaptation: [0xff68, 0xff80, 0xff00, 0xff01, 0xff1b, 0xff59],
      adaptation1: [],
      adaptation24G: [],
    },
    {
      vendorId: 0x0c45,
      productId: 0xfefa,
      productName: "2.4G Dongle",
      displayname: "X98 (1K)",
      identifier: "3141:65274:2.4G Dongle",
      workMode: "2",
      keyboardType: "huafenda98",
      solutionRovider: "huafenda",

      uniqueNumber: "11-1",
      adaptation: [0xff68, 0xff80, 0xff00, 0xff01, 0xff1b, 0xff59],
      adaptation1: [0xff68, 0xff80, 0xff60, 0xff00, 0xff01, 0xff1b, 0xff59],
      adaptation24G: [0xff60],
    },
    {
      vendorId: 0x0c45,
      productId: 0x8035,
      productName: "EWEADN BAT68",
      displayname: "battle68",
      identifier: "3141:32821:EWEADN BAT68",
      workMode: "0",
      keyboardType: "huafenda68",
      solutionRovider: "huafenda",

      uniqueNumber: "12",
      magneticAxis: true,
      adaptation: [0xff68, 0xff80, 0xff00, 0xff01, 0xff1b, 0xff59],
      adaptation1: [],
      adaptation24G: [],
      isSupported: true,
    },
    {
      vendorId: 0x0c45,
      productId: 0x8080,
      productName: "EWEADN BAT68",
      displayname: "battle68",
      identifier: "3141:32896:EWEADN BAT68",
      workMode: "0",
      keyboardType: "huafenda68",
      solutionRovider: "huafenda",

      uniqueNumber: "12",
      magneticAxis: true,
      adaptation: [0xff68, 0xff80, 0xff00, 0xff01, 0xff1b, 0xff59],
      adaptation1: [],
      adaptation24G: [],
      isSupported: true,
    },
    {
      vendorId: 0x0c45,
      productId: 0x8045,
      productName: "Tank68 HE",
      displayname: "Tank68 HE",
      identifier: "3141:32837:Tank68 HE",
      workMode: "0",
      keyboardType: "tank68he",
      solutionRovider: "huafenda",

      uniqueNumber: "13",
      magneticAxis: true,
      adaptation: [0xff68, 0xff80, 0xff00, 0xff01, 0xff1b, 0xff59],
      adaptation1: [],
      adaptation24G: [],
      isSupported: true,
    },
    {
      vendorId: 0x0c45,
      productId: 0x8801,
      productName: "DK108",
      displayname: "DK108",
      identifier: "3141:34817:DK108",
      workMode: "0",
      keyboardType: "DK108",
      solutionRovider: "huafenda",
      uniqueNumber: "14",
      adaptation: [0xff68, 0xff80, 0xff00, 0xff01, 0xff1b, 0xff59],
      adaptation1: [],
      adaptation24G: [],
      isSupported: true,
      skipColorConfig: true,
    },
    {
      vendorId: 0x0c45,
      productId: 0xfefe,
      productName: "2.4G Dongle",
      displayname: "DK108",
      identifier: "3141:65278:2.4G Dongle:1:26",
      workMode: "2",
      keyboardType: "DK108",
      solutionRovider: "huafenda",

      uniqueNumber: "1-1",
      adaptation: [0xff68, 0xff80, 0xff00, 0xff01, 0xff1b, 0xff59],
      adaptation1: [0xff68, 0xff80, 0xff60, 0xff00, 0xff01, 0xff1b, 0xff59],
      adaptation24G: [0xff60],
      isSupported: true,
      skipColorConfig: true,
    },
    {
      vendorId: 0x0c45,
      productId: 0x8804,
      productName: "X87 Neon",
      displayname: "X87 Neon",
      identifier: "3141:34820:X87 Neon",
      workMode: "0",
      keyboardType: "huafenda87",
      solutionRovider: "huafenda",
      adaptation: [0xff68, 0xff80, 0xff00, 0xff01, 0xff1b, 0xff59],
      adaptation1: [],
      adaptation24G: [],
      isSupported: true,
    },
    {
      vendorId: 0x0c45,
      productId: 0xfef9,
      productName: "2.4G Dongle",
      displayname: "X87 Neon",
      identifier: "3141:65273:2.4G Dongle:3:10",
      workMode: "2",
      keyboardType: "huafenda87",
      solutionRovider: "huafenda",
      adaptation: [0xff68, 0xff80, 0xff00, 0xff01, 0xff1b, 0xff59],
      adaptation1: [0xff68, 0xff80, 0xff60, 0xff00, 0xff01, 0xff1b, 0xff59],
      adaptation24G: [0xff60],
      isSupported: true,
    },
    // ES98 8K 有线
    {
      vendorId: 0x372e,
      productId: 0x10b7,
      productName: "EWEADN ES98",
      displayname: "ES98",
      keyboardType: "99",
      solutionRovider: "beiying",

      uniqueNumber: "6",
      adaptation: [0x10b7],
      uuid: [0x140000000004],
      isSupported: true,
    },
    // ES98 8K 无线2.4G大接收器
    {
      vendorId: 0x372e, // 14126
      productId: 0x106c, // 4204
      productName: "EWEADN ES98",
      is4G: true,
      displayname: "ES98",
      keyboardType: "99",
      solutionRovider: "beiying",

      uniqueNumber: "6-2",
      adaptation: [0x106c],
      uuid: [0x140000000004],
      isSupported: true,
    },
    // ES98 8K 无线2.4G小接收器
    {
      vendorId: 0x372e, // 14126
      productId: 0x106c, // 4204
      productName: "8K Wireless Receiver",
      is4G: true,
      displayname: "ES98",
      keyboardType: "99",
      solutionRovider: "beiying",

      uniqueNumber: "6-2",
      adaptation: [0x106c],
      uuid: [0x140000000004],
      isSupported: true,
    },
    // ES98 1K_2.4
    {
      vendorId: 0x372e, // 14126
      productId: 0x10d5, // 4309
      productName: "2.4G Wireless Receiver",
      is4G: true,
      displayname: "ES98",
      keyboardType: "99",
      solutionRovider: "beiying",

      uniqueNumber: "6-3",
      beiyingWirelessConnectType: "Wireless8K",
      adaptation: [0x10d5],
      uuid: [0x140000000004],
      isSupported: true,
    },
    // X98 8K 有线
    {
      vendorId: 0x372e, // 14126
      productId: 0x10b0, // 4272
      productName: "X98",
      displayname: "X98 (8K) Touch",
      keyboardType: "98",
      solutionRovider: "beiying",

      uniqueNumber: "4",
      adaptation: [0x10b0],
      uuid: [0x140000000003],
      isSupported: true,
    },
    // X98 8K 无线2.4G
    {
      vendorId: 0x372e, // 14126
      productId: 0x106c, // 4204
      productName: "X98",
      is4G: true,
      displayname: "X98 (8K) Touch",
      keyboardType: "98",
      solutionRovider: "beiying",

      uniqueNumber: "4-1",
      adaptation: [0x106c],
      uuid: [0x140000000003],
      isSupported: true,
    },
    // X98 8K 有线 中颖方案
    {
      vendorId: 0x391d, // 14621
      productId: 0x200b, // 8203
      productName: "X98",
      displayname: "X98 (8K) Touch",
      keyboardType: "98",
      solutionRovider: "beiying",

      uniqueNumber: "5",
      adaptation: [0x200b],
      uuid: [0x15000000000c],
      isSupported: true,
    },
    // X98 8K 无线2.4G 中颖方案
    {
      vendorId: 0x258a, // 9626
      productId: 0x02d7, // 727
      productName: "X98 Wireless 8K Dongle",
      is4G: true,
      displayname: "X98 (8K) Touch",
      keyboardType: "98",
      solutionRovider: "beiying",

      uniqueNumber: "5-1",
      adaptation: [0x02d7],
      uuid: [0x15000000000c],
      isSupported: true,
    },
    // X98 1K 有线
    {
      vendorId: 0x258a,
      productId: 0x01b9,
      productName: "X98  ",
      displayname: "X98 (1K) Touch",
      keyboardType: "98",
      solutionRovider: "beiying",

      uniqueNumber: "3",
      adaptation: [0x01b9],
      uuid: [0x0a0000000038],
    },
    // X98 1K 无线2.4G
    {
      vendorId: 0x258a,
      productId: 0x0233,
      productName: "Gaming KB ",
      is4G: true,
      displayname: "X98 (1K) Touch",
      keyboardType: "98",
      solutionRovider: "beiying",

      uniqueNumber: "3-1",
      adaptation: [0x0233],
      uuid: [0x0a0000000038],
    },
    // MUSE M80 有线 — SDK Device916 / DeviceWireLess916（demo keyboard916.vue）
    {
      vendorId: 0x258a, // 9610
      productId: 0x010c, // 268
      productName: "MUSE M80",
      displayname: "MUSE M80",
      keyboardType: "m80",
      solutionRovider: "beiying",

      uniqueNumber: "7",
      adaptation: [0x010c],
      uuid: [0x300000003dd],
      sdkType: SDK_KEYBOARD_MOUSE_TYPE.keyboard.beiyingMachine,
      machineBoard: "916",
    },
    // MUSE M80 2.4G 无线 — SDK Device916 / DeviceWireLess916（demo keyboard916.vue）
    {
      vendorId: 0x3554, // 13652
      productId: 0xfa09, // 64009
      productName: "2.4G Wireless Receiver",
      is4G: true,
      displayname: "MUSE M80",
      keyboardType: "m80",
      solutionRovider: "beiying",

      uniqueNumber: "7-1",
      adaptation: [0xfa09],
      uuid: [0x300000003dd],
      sdkType: SDK_KEYBOARD_MOUSE_TYPE.keyboard.beiyingMachine,
      machineBoard: "916",
    },
    // Gaming Keyboard (M71) 有线 — 表项与连接匹配逻辑已撤回至合并前；需要时按实机 vid/pid/productName 再启用
    {
      vendorId: 0x258a,
      productId: 0x010c,
      productName: "Gaming Keyboard",
      displayname: "M71",
      keyboardType: "m71",
      solutionRovider: "beiying",

      uniqueNumber: "8",
      adaptation: [0x010c],
      uuid: [0x0300000000cc],
      sdkType: SDK_KEYBOARD_MOUSE_TYPE.keyboard.beiyingMachine,
      machineBoard: "916",
    },
    {
      vendorId: 0x258a,
      productId: 0x010c,
      productName: "Gaming Keyboard",
      displayname: "T87",
      keyboardType: "t87",
      solutionRovider: "beiying",

      uniqueNumber: "9",
      adaptation: [0x010c],
      uuid: [0x0300000000c6],
      sdkType: SDK_KEYBOARD_MOUSE_TYPE.keyboard.beiyingMachine,
      machineBoard: "916",
    },
    {
      vendorId: 0x3554, // 13652
      productId: 0xfa09, // 64009
      productName: "2.4G Wireless Receiver",
      is4G: true,
      displayname: "T87",
      keyboardType: "t87",
      solutionRovider: "beiying",

      uniqueNumber: "9-1",
      adaptation: [0xfa09],
      uuid: [0x0300000000c6],
      sdkType: SDK_KEYBOARD_MOUSE_TYPE.keyboard.beiyingMachine,
      machineBoard: "916",
    },
    {
      vendorId: 0x258a,
      productId: 0x010c,
      productName: "Gaming Keyboard",
      displayname: "M75",
      keyboardType: "m75",
      solutionRovider: "beiying",

      uniqueNumber: "10",
      adaptation: [0x010c],
      uuid: [0x0300000001ec],
      sdkType: SDK_KEYBOARD_MOUSE_TYPE.keyboard.beiyingMachine,
      machineBoard: "916",
      isSupported: true,
    },
    {
      vendorId: 0x3554,
      productId: 0xfa09,
      productName: "2.4G Wireless Receiver",
      is4G: true,
      displayname: "M75",
      keyboardType: "m75",
      solutionRovider: "beiying",

      uniqueNumber: "10-1",
      adaptation: [0xfa09],
      uuid: [0x0300000001ec],
      sdkType: SDK_KEYBOARD_MOUSE_TYPE.keyboard.beiyingMachine,
      machineBoard: "916",
      isSupported: true,
    },
    {
      vendorId: 0x372e,
      productId: 0x10eb,
      productName: "EXX Alpha 87",
      displayname: "Alpha 87",
      keyboardType: "es87",
      solutionRovider: "beiying",

      uniqueNumber: "1",
      adaptation: [0x10eb, 0x372e],
      uuid: [0x160000000003],
      isSupported: true,
      brand: "EXX",
    },
    {
      vendorId: 0x1ca6, // 7334
      productId: 0x1c2d, // 7230
      productName: "X75 ULTRA",
      displayname: "X75 Ultra",
      keyboardType: "x75v3",
      solutionRovider: "xingshan",

      uniqueNumber: "24",
      adaptation: [],
      isSupported: true,
    },
    {
      vendorId: 0x1ca6, // 7334
      productId: 0x1c2d, // 7230
      productName: "EXXGamma75",
      displayname: "Gamma75",
      keyboardType: "x75v3",
      solutionRovider: "xingshan",

      uniqueNumber: "29",
      adaptation: [],
      isSupported: true,
      brand: "EXX",
    },
    {
      vendorId: 0x258a,
      productId: 0x02d8,
      productName: "EXX Alpha 87",
      is4G: true,
      displayname: "Alpha 87",
      keyboardType: "es87",
      solutionRovider: "beiying",

      uniqueNumber: "1-1",
      adaptation: [0x02d8, 0x258a],
      uuid: [0x160000000003],
      isSupported: true,
      brand: "EXX",
    },
    {
      vendorId: 0x1ca6, // 7334
      productId: 0x1c0c, // 7180
      productName: "DEEP80 MAX",
      displayname: "DEEP80 MAX",
      keyboardType: "deep80max",
      solutionRovider: "xingshan",

      uniqueNumber: "30",
      adaptation: [],
      isSupported: true,
    },
    // 容园磁轴 DEEP Pro / DEEP68（rongyuan2 = 外链跳转 hub，非驱动内 rongyuan 机械轴）
    {
      vendorId: 0x3151, // 12625
      productId: 0x5029, // 20521 — 与 DEEP68 同 PID，靠 productName 区分
      productName: "DEEP80 Pro",
      displayname: "DEEP80 Pro",
      keyboardType: "deep80max",
      solutionRovider: "rongyuan2",

      uniqueNumber: "2",
      adaptation: [],
      isSupported: true,
      url: "https://hub.eweadn.cn/#/",
    },
    {
      vendorId: 0x3151, // 12625
      productId: 0x5029, // 20521
      productName: "DEEP68",
      displayname: "DEEP68",
      keyboardType: "deep80max",
      solutionRovider: "rongyuan2",

      uniqueNumber: "1",
      adaptation: [],
      isSupported: true,
      url: "https://hub.eweadn.cn/#/",
    },
    // —— 容园机械轴（驱动内 rongyuan 方案，与上方磁轴 DEEP 无关；勿配 link/url，否则会当外链跳转）——
    {
      vendorId: 0x3151, // 12625
      productId: 0x504c, // 20556 有线
      productName: "X87S",
      displayname: "X87S",
      keyboardType: "rongyuan87",
      solutionRovider: "rongyuan",
      uniqueNumber: "1",
      usagePage: 0xffb0,
      usage: 0x01,
      adaptation: [],
      isSupported: true,
    },
    {
      vendorId: 0x3151, // 12625
      productId: 0x504e, // 20558 2.4G 接收器
      productName: "2.4G Wireless Keyboard",
      displayname: "X87S",
      keyboardType: "rongyuan87",
      solutionRovider: "rongyuan",
      uniqueNumber: "2",
      usagePage: 0xffff,
      usage: 0x0002,
      is4G: true,
      adaptation: [],
      isSupported: true,
    },
    // X87S 洛天依联名（2.4G 接收器 HID productName 为 X87S，与同 PID 公版 2.4G 区分）
    {
      vendorId: 0x3151, // 12625
      productId: 0x504e, // 20558 2.4G 接收器
      productName: "X87S",
      displayname: "X87S TIANYI",
      keyboardType: "rongyuan87",
      solutionRovider: "rongyuan",
      uniqueNumber: "2",
      usagePage: 0xffff,
      usage: 0x0002,
      is4G: true,
      adaptation: [],
      isSupported: true,
      // 预设壁纸 + 进子应用自动应用洛天依官方 UI 套装（同 ES68 TIANYI / VX07）
      licensorId: 1,
    },
    {
      vendorId: 0x3151,
      productId: 0x5030,
      productName: "DEEP68 ",
      displayname: "DEEP68",
      keyboardType: "deep80max",
      solutionRovider: "rongyuan",
      uniqueNumber: "3",
      usagePage: 0xffb0,
      usage: 0x01,
      adaptation: [],
      isSupported: true,
      link: {
        vendor: "ry",
        channel: "web",
        action: "connect",
        queryMode: "auto",
      },
    },
    {
      vendorId: 0x3151,
      productId: 0x5026,
      productName: "2.4G Wireless Keyboard",
      displayname: "DEEP68",
      keyboardType: "deep68",
      solutionRovider: "rongyuan",
      uniqueNumber: "4",
      usagePage: 0xffff,
      usage: 0x0002,
      protocol: "ry-receiver",
      deviceIds: [
        { id: "0xA97", titleName: "DEEP68" },
        { id: "0xA12", titleName: "DEEP68" },
        { id: "0xA96", titleName: "DEEP68" },
      ],
      adaptation: [],
      isSupported: true,
      link: {
        vendor: "ry",
        channel: "web",
        action: "connect",
        queryMode: "auto",
      },
    },
    {
      vendorId: 0x3151,
      productId: 0x502b,
      productName: "2.4G Wireless Keyboard",
      displayname: "DEEP68",
      keyboardType: "deep68",
      solutionRovider: "rongyuan",
      uniqueNumber: "5",
      usagePage: 0xffff,
      usage: 0x0002,
      protocol: "ry-receiver",
      deviceIds: [
        { id: "0xA97", titleName: "DEEP68" },
        { id: "0xA12", titleName: "DEEP68" },
        { id: "0xA96", titleName: "DEEP68" },
      ],
      adaptation: [],
      isSupported: true,
      link: {
        vendor: "ry",
        channel: "web",
        action: "connect",
        queryMode: "auto",
      },
    },
    {
      vendorId: 0x3151,
      productId: 0x502f,
      productName: "ZAP68",
      displayname: "ZAP68",
      keyboardType: "68",
      solutionRovider: "rongyuan",
      uniqueNumber: "6",
      adaptation: [],
      isSupported: true,
      skipColorConfig: true,
      link: {
        vendor: "ry",
        channel: "web",
        action: "connect",
        queryMode: "auto",
      },
    },
    {
      vendorId: 0x3151,
      productId: 0x502d,
      productName: "ZAP68",
      displayname: "ZAP68",
      keyboardType: "68",
      solutionRovider: "rongyuan",
      uniqueNumber: "7",
      adaptation: [],
      isSupported: true,
      skipColorConfig: true,
      link: {
        vendor: "ry",
        channel: "web",
        action: "connect",
        queryMode: "auto",
      },
    },
    {
      vendorId: 0x3151,
      productId: 0x5026,
      productName: "2.4G Wireless Keyboard",
      displayname: "ZAP68",
      keyboardType: "68",
      solutionRovider: "rongyuan",
      uniqueNumber: "8",
      usagePage: 0xffff,
      usage: 0x0002,
      protocol: "ry-receiver",
      deviceIds: [{ id: "0x97A", titleName: "ZAP68" }],
      adaptation: [],
      isSupported: true,
      skipColorConfig: true,
      link: {
        vendor: "ry",
        channel: "web",
        action: "connect",
        queryMode: "auto",
      },
    },
    {
      vendorId: 0x3151,
      productId: 0x502b,
      productName: "2.4G Wireless Keyboard",
      displayname: "ZAP68",
      keyboardType: "68",
      solutionRovider: "rongyuan",
      uniqueNumber: "9",
      usagePage: 0xffff,
      usage: 0x0002,
      protocol: "ry-receiver",
      deviceIds: [{ id: "0x97A", titleName: "ZAP68" }],
      adaptation: [],
      isSupported: true,
      skipColorConfig: true,
      link: {
        vendor: "ry",
        channel: "web",
        action: "connect",
        queryMode: "auto",
      },
    },
    {
      vendorId: 0x05ac,
      productId: 0x024f,
      productName: "DKkeyboard",
      displayname: "V80",
      deviceId: "v80",
      identifier: "1452:591:DKkeyboard",
      workMode: "0",
      /** 公版 TKL；同 VID/PID 的 V102 在建连读 drvSN 后特化为 V102 */
      keyboardType: "87",
      solutionRovider: "dakai",
      uniqueNumber: "1",
      protocol: "dakai-hid",
      adaptation: [0x00c0, 0x008c, 0xff00],
      adaptation1: [],
      adaptation24G: [],
      communitySupported: false,
      isSupported: true,
    },
    {
      /** V102 2.4G 接收器：与有线同 VID/PID，靠 productName「2.4G」区分；drvSN 仍可特化为 V80 */
      vendorId: 0x05ac,
      productId: 0x024f,
      productName: "2.4G",
      displayname: "V102",
      deviceId: "v102",
      identifier: "1452:591:2.4G",
      workMode: "2",
      is4G: true,
      keyboardType: "v102",
      solutionRovider: "dakai",
      protocol: "dakai-hid",
      adaptation: [0x00c0, 0x008c, 0xff00],
      adaptation1: [],
      adaptation24G: [],
      communitySupported: false,
      isSupported: true,
    },
    {
      vendorId: 0x28e9,
      productId: 0x3209,
      productName: "EWEADN-DK87",
      displayname: "DK87",
      keyboardType: "dk87",
      solutionRovider: "ZHWX",
      uniqueNumber: "1",
      usagePage: 0xff87,
      usage: 0x20,
      adaptation: [],
      isSupported: true,
    },
    {
      vendorId: 0x056d,
      productId: 0xc077,
      productName: "EWEADN-DK87",
      displayname: "DK87",
      keyboardType: "dk87",
      solutionRovider: "ZHWX",
      uniqueNumber: "2",
      is4G: true,
      workMode: "2",
      usagePage: 0xff87,
      usage: 0x20,
      adaptation: [],
      isSupported: true,
    },
    {
      vendorId: 0x28e9,
      productId: 0x31fc,
      productName: "EWEADN-DK75",
      displayname: "DK75 Single",
      keyboardType: "dk75Single",
      solutionRovider: "ZHWX",
      uniqueNumber: "3",
      usagePage: 0xff87,
      usage: 0x20,
      adaptation: [],
      isSupported: true,
    },
    {
      vendorId: 0x36ae,
      productId: 0xfeac,
      productName: "SDCXOther",
      displayname: "DK63 Machine",
      keyboardType: "dk63Machine",
      solutionRovider: "SDCX",
      uniqueNumber: "1",
      usagePage: 0xff00,
      usage: 0x01,
      adaptation: [],
      isSupported: true,
      skipColorConfig: true,
    },
  ],
  mouse: [
    {
      vendorId: 0x372e,
      productId: 0x107c,
      productName: "EWEADN S7Max",
      displayname: "S7 Max",
      deviceId: "s7max",
      sensor: "3395",
      is4G: false,
      uuid: [9895604650046],
      solutionRovider: "beiying",

      uniqueNumber: "6",
      hidReportId: 3,
      isSupported: true,
    },
    {
      vendorId: 0x372e,
      productId: 0x103d,
      productName: "EWEADN S7Max",
      displayname: "S7 Max",
      deviceId: "s7max",
      sensor: "3395",
      is4G: true,
      uuid: [9895604650046],
      solutionRovider: "beiying",

      uniqueNumber: "6-1",
      hidReportId: 3,
      isSupported: true,
    },
    {
      vendorId: 0x372e,
      productId: 0x106e,
      productName: "EWEADN S7Max",
      displayname: "S7 Max",
      deviceId: "s7max",
      sensor: "3395",
      is4G: true,
      uuid: [9895604650046],
      solutionRovider: "beiying",

      uniqueNumber: "6-2",
      hidReportId: 3,
      isSupported: true,
    },
    {
      vendorId: 0x372e,
      productId: 0x1026,
      productName: "EWEADN S7Max",
      displayname: "S7 Max",
      deviceId: "s7max",
      sensor: "3395",
      is4G: true,
      uuid: [9895604650046],
      solutionRovider: "beiying",

      uniqueNumber: "6-3",
      hidReportId: 3,
      isSupported: true,
    },
    {
      vendorId: 0x372e,
      productId: 0x107b,
      productName: "EWEADN S7Pro",
      displayname: "S7 Pro",
      deviceId: "s7pro",
      sensor: "3395",
      is4G: false,
      uuid: [9895604650045],
      solutionRovider: "beiying",

      uniqueNumber: "5",
      hidReportId: 3,
      maxReportRateHz: 1000,
      isSupported: true,
    },
    {
      vendorId: 0x372e,
      productId: 0x103d,
      productName: "EWEADN S7Pro",
      displayname: "S7 Pro",
      deviceId: "s7pro",
      sensor: "3395",
      is4G: true,
      uuid: [9895604650045],
      solutionRovider: "beiying",

      uniqueNumber: "5-1",
      hidReportId: 3,
      isSupported: true,
    },
    {
      vendorId: 0x372e,
      productId: 0x1026,
      productName: "EWEADN S7Pro",
      displayname: "S7 Pro",
      deviceId: "s7pro",
      sensor: "3395",
      is4G: true,
      uuid: [9895604650045],
      solutionRovider: "beiying",

      uniqueNumber: "5-2",
      hidReportId: 3,
      isSupported: true,
    },
    {
      vendorId: 0x372e,
      productId: 0x108a,
      productName: "EWEADN S7Ultra",
      displayname: "S7 Ultra",
      deviceId: "s7ultra",
      sensor: "3950",
      is4G: false,
      uuid: [9895604650056],
      solutionRovider: "beiying",

      uniqueNumber: "7",
      hidReportId: 3,
      isSupported: true,
    },
    {
      vendorId: 0x372e,
      productId: 0x103d,
      productName: "EWEADN S7Ultra",
      displayname: "S7 Ultra",
      deviceId: "s7ultra",
      sensor: "3950",
      is4G: true,
      uuid: [9895604650056],
      solutionRovider: "beiying",

      uniqueNumber: "7-1",
      hidReportId: 3,
      isSupported: true,
    },
    {
      vendorId: 0x372e,
      productId: 0x106e,
      productName: "EWEADN S7Ultra",
      displayname: "S7 Ultra",
      deviceId: "s7ultra",
      sensor: "3950",
      is4G: true,
      uuid: [9895604650056],
      solutionRovider: "beiying",

      uniqueNumber: "7-2",
      hidReportId: 3,
      isSupported: true,
    },
    {
      vendorId: 0x372e,
      productId: 0x1026,
      productName: "EWEADN S7Ultra",
      displayname: "S7 Ultra",
      deviceId: "s7ultra",
      sensor: "3950",
      is4G: true,
      uuid: [9895604650056],
      solutionRovider: "beiying",

      uniqueNumber: "7-3",
      hidReportId: 3,
      isSupported: true,
    },
    {
      vendorId: 0x372e,
      productId: 0x105e,
      productName: "EWEADN S9 Max",
      displayname: "S9 Max",
      deviceId: "s9max",
      sensor: "3395",
      is4G: false,
      uuid: [9895604650026],
      solutionRovider: "beiying",

      uniqueNumber: "2",
      hidReportId: 3,
      isSupported: true,
    },
    {
      vendorId: 0x372e,
      productId: 0x1026,
      productName: "EWEADN S9", // 2.4G 8K接收器（同 pid/vid，不同 uuid）
      displayname: "S9 Max",
      deviceId: "s9max",
      sensor: "3395",
      is4G: true,
      uuid: [9895604650026],
      solutionRovider: "beiying",

      uniqueNumber: "2-1",
      hidReportId: 3,
      isSupported: true,
    },
    {
      vendorId: 0x372e,
      productId: 0x103d,
      productName: "Gaming 2.4G", // 2.4G 1K接收器（同 pid/vid，不同 uuid）
      displayname: "S9 Max",
      deviceId: "s9max",
      sensor: "3395",
      is4G: true,
      uuid: [9895604650026],
      solutionRovider: "beiying",

      uniqueNumber: "2-2",
      hidReportId: 3,
      maxReportRateHz: 1000,
      isSupported: true,
    },
    {
      vendorId: 0x372e,
      productId: 0x1029,
      productName: "EWEADN S9 Pro",
      displayname: "S9 Pro",
      deviceId: "s9pro",
      sensor: "3395",
      is4G: false,
      uuid: [9895604649998],
      solutionRovider: "beiying",

      uniqueNumber: "1",
      hidReportId: 3,
      maxReportRateHz: 1000,
      isSupported: true,
    },
    {
      vendorId: 0x372e,
      productId: 0x1026,
      productName: "EWEADN S9", // 2.4G 8K接收器（同 pid/vid，不同 uuid）
      displayname: "S9 Pro",
      deviceId: "s9pro",
      sensor: "3395",
      is4G: true,
      uuid: [9895604649998],
      solutionRovider: "beiying",

      uniqueNumber: "1-1",
      hidReportId: 3,
      isSupported: true,
    },
    {
      vendorId: 0x372e,
      productId: 0x103d,
      productName: "Gaming 2.4G", // 2.4G 1K接收器（同 pid/vid，不同 uuid）
      displayname: "S9 Pro",
      deviceId: "s9pro",
      sensor: "3395",
      is4G: true,
      uuid: [9895604649998],
      solutionRovider: "beiying",

      uniqueNumber: "1-2",
      hidReportId: 3,
      maxReportRateHz: 1000,
      isSupported: true,
    },
    {
      vendorId: 0x372e,
      productId: 0x1027,
      productName: "EWEADN S9 Ultra",
      displayname: "S9 Ultra",
      deviceId: "s9ultra",
      sensor: "3950",
      is4G: false,
      uuid: [9895604650000],
      solutionRovider: "beiying",

      uniqueNumber: "4",
      hidReportId: 3,
      isSupported: true,
    },
    {
      vendorId: 0x372e,
      productId: 0x1026,
      productName: "EWEADN S9", // 2.4G 8K接收器（同 pid/vid，不同 uuid）
      displayname: "S9 Ultra",
      deviceId: "s9ultra",
      sensor: "3950",
      is4G: true,
      uuid: [9895604650000],
      solutionRovider: "beiying",

      uniqueNumber: "4-1",
      hidReportId: 3,
      isSupported: true,
    },
    {
      vendorId: 0x372e,
      productId: 0x103d,
      productName: "Gaming 2.4G", // 2.4G 1K接收器（同 pid/vid，不同 uuid）
      displayname: "S9 Ultra",
      deviceId: "s9ultra",
      sensor: "3950",
      is4G: true,
      uuid: [9895604650000],
      solutionRovider: "beiying",

      uniqueNumber: "4-2",
      hidReportId: 3,
      maxReportRateHz: 1000,
      isSupported: true,
    },
    {
      vendorId: 0x372e,
      productId: 0x108d,
      productName: "EWEADN S9Ultra+",
      displayname: "S9 Ultra+",
      deviceId: "s9ultra+",
      sensor: "3950",
      is4G: false,
      uuid: [9895604650058],
      solutionRovider: "beiying",

      uniqueNumber: "3",
      hidReportId: 3,
      isSupported: true,
    },
    {
      vendorId: 0x372e,
      productId: 0x1026,
      productName: "EWEADN S9", // 2.4G 8K接收器（同 pid/vid，不同 uuid）
      displayname: "S9 Ultra+",
      deviceId: "s9ultra+",
      sensor: "3950",
      is4G: true,
      uuid: [9895604650058],
      solutionRovider: "beiying",

      uniqueNumber: "3-1",
      hidReportId: 3,
      isSupported: true,
    },
    {
      vendorId: 0x372e,
      productId: 0x103d,
      productName: "Gaming 2.4G", // 2.4G 1K接收器（同 pid/vid，不同 uuid）
      displayname: "S9 Ultra+",
      deviceId: "s9ultra+",
      sensor: "3950",
      is4G: true,
      uuid: [9895604650058],
      solutionRovider: "beiying",

      uniqueNumber: "3-2",
      hidReportId: 3,
      maxReportRateHz: 1000,
      isSupported: true,
    },
    {
      vendorId: 0xa8a4,
      productId: 0x2255,
      productName: "EWEADN A6",
      displayname: "A6",
      deviceId: "a6",
      sensor: "3311A",
      solutionRovider: "freq",

      uniqueNumber: "19",
      freqLinkHint: "c",
      usage: 0x0010,
      usagePage: 0xff01,
      maxReportRateHz: 1000,
      reportRateSwitchable: false,
      isSupported: true,
    },
    {
      vendorId: 0xa8a5,
      productId: 0x2255,
      productName: "EWEADN A6",
      displayname: "A6",
      deviceId: "a6",
      sensor: "3311A",
      solutionRovider: "freq",

      uniqueNumber: "19-1",
      freqLinkHint: "c",
      usage: 0x0010,
      usagePage: 0xff01,
      maxReportRateHz: 1000,
      reportRateSwitchable: true,
      isSupported: true,
    },
    {
      vendorId: 0xa8a4,
      productId: 0x2255,
      productName: "EWEADN A6Max",
      displayname: "A6 Max",
      deviceId: "a6max",
      sensor: "3395",
      solutionRovider: "freq",

      uniqueNumber: "10",
      usage: 0x0010,
      usagePage: 0xff01,
      maxReportRateHz: 1000,
      reportRateSwitchable: true,
      isSupported: true,
    },
    {
      vendorId: 0xa8a5,
      productId: 0x2255,
      productName: "EWEADN A6Max",
      displayname: "A6 Max",
      deviceId: "a6max",
      sensor: "3395",
      solutionRovider: "freq",

      uniqueNumber: "10-1",
      usage: 0x0010,
      usagePage: 0xff01,
      maxReportRateHz: 1000,
      reportRateSwitchable: true,
      isSupported: true,
    },
    {
      vendorId: 0xa8a4,
      productId: 0x2255,
      productName: "EWEADN A6Pro",
      displayname: "A6 Pro",
      deviceId: "a6pro",
      sensor: "3315",
      solutionRovider: "freq",

      uniqueNumber: "9",
      usage: 0x0010,
      usagePage: 0xff01,
      maxReportRateHz: 1000,
      reportRateSwitchable: false,
      isSupported: true,
    },
    {
      vendorId: 0xa8a5,
      productId: 0x2255,
      productName: "EWEADN A6Pro",
      displayname: "A6 Pro",
      deviceId: "a6pro",
      sensor: "3315",
      solutionRovider: "freq",

      uniqueNumber: "9-1",
      usage: 0x0010,
      usagePage: 0xff01,
      maxReportRateHz: 1000,
      reportRateSwitchable: true,
      isSupported: true,
    },
    {
      vendorId: 0xa8a4,
      productId: 0x2255,
      productName: "EWEADN A7",
      displayname: "A7",
      deviceId: "a7",
      sensor: "3311",
      solutionRovider: "freq",

      uniqueNumber: "12",
      usage: 0x0010,
      usagePage: 0xff01,
      maxReportRateHz: 1000,
      reportRateSwitchable: false,
      isSupported: true,
    },
    {
      vendorId: 0xa8a5,
      productId: 0x2255,
      productName: "EWEADN A7",
      displayname: "A7",
      deviceId: "a7",
      sensor: "3311",
      solutionRovider: "freq",

      uniqueNumber: "12-1",
      usage: 0x0010,
      usagePage: 0xff01,
      maxReportRateHz: 1000,
      reportRateSwitchable: true,
      isSupported: true,
    },
    {
      vendorId: 0xa8a4,
      productId: 0x2255,
      productName: "EWEADN A7Pro",
      displayname: "A7 Pro",
      deviceId: "a7pro",
      sensor: "3395",
      solutionRovider: "freq",

      uniqueNumber: "13",
      usage: 0x0010,
      usagePage: 0xff01,
      maxReportRateHz: 1000,
      reportRateSwitchable: true,
      isSupported: true,
    },
    {
      vendorId: 0xa8a5,
      productId: 0x2255,
      productName: "EWEADN A7Pro",
      displayname: "A7 Pro",
      deviceId: "a7pro",
      sensor: "3395",
      solutionRovider: "freq",

      uniqueNumber: "13-1",
      usage: 0x0010,
      usagePage: 0xff01,
      maxReportRateHz: 1000,
      reportRateSwitchable: true,
      isSupported: true,
    },
    {
      vendorId: 0xa8a4,
      productId: 0x2255,
      productName: "EWEADN A7SE",
      displayname: "A7 SE",
      deviceId: "a7se",
      sensor: "3311",
      solutionRovider: "freq",

      uniqueNumber: "11",
      usage: 0x0010,
      usagePage: 0xff01,
      maxReportRateHz: 1000,
      reportRateSwitchable: false,
      isSupported: true,
    },
    {
      vendorId: 0xa8a5,
      productId: 0x2255,
      productName: "EWEADN A7SE",
      displayname: "A7 SE",
      deviceId: "a7se",
      sensor: "3311",
      solutionRovider: "freq",

      uniqueNumber: "11-1",
      usage: 0x0010,
      usagePage: 0xff01,
      maxReportRateHz: 1000,
      reportRateSwitchable: true,
      isSupported: true,
    },
    {
      vendorId: 0xa8a4,
      productId: 0x2255,
      productName: "EWEADN E11",
      displayname: "E11",
      deviceId: "e11",
      sensor: "S203",
      solutionRovider: "freq",

      uniqueNumber: "17",
      freqLinkHint: "c",
      usage: 0x0010,
      usagePage: 0xff01,
      maxReportRateHz: 1000,
      reportRateSwitchable: false,
      isSupported: true,
    },
    {
      vendorId: 0xa8a5,
      productId: 0x2255,
      productName: "EWEADN E11",
      displayname: "E11",
      deviceId: "e11",
      sensor: "S203",
      solutionRovider: "freq",

      uniqueNumber: "17-1",
      freqLinkHint: "c",
      usage: 0x0010,
      usagePage: 0xff01,
      maxReportRateHz: 1000,
      reportRateSwitchable: true,
      isSupported: true,
    },
    {
      vendorId: 0xa8a4,
      productId: 0x2255,
      productName: "EWEADN E11 PRO",
      displayname: "E11 Pro",
      deviceId: "e11pro",
      sensor: "3311A",
      solutionRovider: "freq",

      uniqueNumber: "18",
      freqLinkHint: "c",
      usage: 0x0010,
      usagePage: 0xff01,
      maxReportRateHz: 1000,
      reportRateSwitchable: false,
      isSupported: true,
    },
    {
      vendorId: 0xa8a5,
      productId: 0x2255,
      productName: "EWEADN E11 PRO",
      displayname: "E11 Pro",
      deviceId: "e11pro",
      sensor: "3311A",
      solutionRovider: "freq",

      uniqueNumber: "18-1",
      freqLinkHint: "c",
      usage: 0x0010,
      usagePage: 0xff01,
      maxReportRateHz: 1000,
      reportRateSwitchable: true,
      isSupported: true,
    },
    {
      vendorId: 0xa8a4,
      productId: 0x2255,
      productName: "EWEADN E7",
      displayname: "E7",
      deviceId: "e7",
      sensor: "S203",
      solutionRovider: "freq",

      uniqueNumber: "14",
      freqLinkHint: "c",
      usage: 0x0010,
      usagePage: 0xff01,
      maxReportRateHz: 1000,
      reportRateSwitchable: false,
      isSupported: true,
    },
    {
      vendorId: 0xa8a5,
      productId: 0x2255,
      productName: "EWEADN E7",
      displayname: "E7",
      deviceId: "e7",
      sensor: "S203",
      solutionRovider: "freq",

      uniqueNumber: "14-1",
      freqLinkHint: "c",
      usage: 0x0010,
      usagePage: 0xff01,
      maxReportRateHz: 1000,
      reportRateSwitchable: true,
      isSupported: true,
    },
    {
      vendorId: 0xa8a4,
      productId: 0x2255,
      productName: "EWEADN E7 PRO",
      displayname: "E7 Pro",
      deviceId: "e7Pro",
      sensor: "3311A",
      solutionRovider: "freq",

      uniqueNumber: "15",
      freqLinkHint: "c",
      usage: 0x0010,
      usagePage: 0xff01,
      maxReportRateHz: 1000,
      reportRateSwitchable: false,
      isSupported: true,
    },
    {
      vendorId: 0xa8a5,
      productId: 0x2255,
      productName: "EWEADN E7 PRO",
      displayname: "E7 Pro",
      deviceId: "e7Pro",
      sensor: "3311A",
      solutionRovider: "freq",

      uniqueNumber: "15-1",
      freqLinkHint: "c",
      usage: 0x0010,
      usagePage: 0xff01,
      maxReportRateHz: 1000,
      reportRateSwitchable: true,
      isSupported: true,
    },
    {
      vendorId: 0xa8a4,
      productId: 0x2255,
      productName: "EWEADN E9",
      displayname: "E9",
      deviceId: "e9",
      sensor: "S203",
      solutionRovider: "freq",

      uniqueNumber: "16",
      freqLinkHint: "c",
      usage: 0x0010,
      usagePage: 0xff01,
      maxReportRateHz: 1000,
      reportRateSwitchable: false,
      isSupported: true,
    },
    {
      vendorId: 0xa8a5,
      productId: 0x2255,
      productName: "EWEADN E9",
      displayname: "E9",
      deviceId: "e9",
      sensor: "S203",
      solutionRovider: "freq",

      uniqueNumber: "16-1",
      freqLinkHint: "c",
      usage: 0x0010,
      usagePage: 0xff01,
      maxReportRateHz: 1000,
      reportRateSwitchable: true,
      isSupported: true,
    },
    {
      vendorId: 0xa8a4,
      productId: 0x2255,
      productName: "E9Carbon",
      displayname: "E9 Carbon",
      deviceId: "e9carbon",
      sensor: "S203",
      solutionRovider: "freq",
      uniqueNumber: "24",
      freqLinkHint: "c",
      usage: 0x0010,
      usagePage: 0xff01,
      maxReportRateHz: 1000,
      reportRateSwitchable: false,
      isSupported: true,
    },
    {
      vendorId: 0xa8a5,
      productId: 0x2255,
      productName: "E9Carbon",
      displayname: "E9 Carbon",
      deviceId: "e9carbon",
      sensor: "S203",
      solutionRovider: "freq",
      uniqueNumber: "24-1",
      freqLinkHint: "c",
      usage: 0x0010,
      usagePage: 0xff01,
      maxReportRateHz: 1000,
      reportRateSwitchable: true,
      isSupported: true,
    },
    {
      vendorId: 0xa8a4,
      productId: 0x2255,
      productName: "E9ProCarbon",
      displayname: "E9 Pro Carbon",
      deviceId: "e9procarbon",
      sensor: "3311A",
      solutionRovider: "freq",
      uniqueNumber: "25",
      freqLinkHint: "c",
      usage: 0x0010,
      usagePage: 0xff01,
      maxReportRateHz: 1000,
      reportRateSwitchable: false,
      isSupported: true,
    },
    {
      vendorId: 0xa8a5,
      productId: 0x2255,
      productName: "E9ProCarbon",
      displayname: "E9 Pro Carbon",
      deviceId: "e9procarbon",
      sensor: "3311A",
      solutionRovider: "freq",
      uniqueNumber: "25-1",
      freqLinkHint: "c",
      usage: 0x0010,
      usagePage: 0xff01,
      maxReportRateHz: 1000,
      reportRateSwitchable: true,
      isSupported: true,
    },
    {
      vendorId: 0xa8a4,
      productId: 0x2255,
      productName: "EWEADN G2SE A",
      displayname: "G2SE A",
      deviceId: "g2sea",
      sensor: "3311A",
      solutionRovider: "freq",

      uniqueNumber: "23",
      freqLinkHint: "c",
      usage: 0x0010,
      usagePage: 0xff01,
      maxReportRateHz: 1000,
      reportRateSwitchable: false,
      isSupported: true,
    },
    {
      vendorId: 0xa8a5,
      productId: 0x2255,
      productName: "EWEADN G2SE A",
      displayname: "G2SE A",
      deviceId: "g2sea",
      sensor: "3311A",
      solutionRovider: "freq",

      uniqueNumber: "23-1",
      freqLinkHint: "c",
      usage: 0x0010,
      usagePage: 0xff01,
      maxReportRateHz: 1000,
      reportRateSwitchable: true,
      isSupported: true,
    },
    {
      vendorId: 0xa8a4,
      productId: 0x2255,
      productName: "EWEADN G5",
      displayname: "G5",
      deviceId: "g5",
      is4G: false,
      solutionRovider: "freq",

      uniqueNumber: "22",
      isSupported: true,
      url: "https://eweadn.yjx2012.com/",
    },
    {
      vendorId: 0xa8a5,
      productId: 0x2255,
      productName: "EWEADN G5",
      displayname: "G5",
      deviceId: "g5",
      is4G: true,
      solutionRovider: "freq",

      uniqueNumber: "22-1",
      isSupported: true,
      url: "https://eweadn.yjx2012.com/",
    },
    {
      vendorId: 0xa8a4,
      productId: 0x2255,
      productName: "EWEADN S2",
      displayname: "S2",
      deviceId: "s2",
      sensor: "3315A",
      solutionRovider: "freq",
      uniqueNumber: "27",
      freqLinkHint: "c",
      usage: 0x0010,
      usagePage: 0xff01,
      maxReportRateHz: 1000,
      reportRateSwitchable: false,
      isSupported: true,
    },
    {
      vendorId: 0xa8a5,
      productId: 0x2255,
      productName: "EWEADN S2",
      displayname: "S2",
      deviceId: "s2",
      sensor: "3315A",
      solutionRovider: "freq",
      uniqueNumber: "27-1",
      freqLinkHint: "c",
      usage: 0x0010,
      usagePage: 0xff01,
      maxReportRateHz: 1000,
      reportRateSwitchable: true,
      isSupported: true,
    },
    {
      vendorId: 0xa8a4,
      productId: 0x2255,
      productName: "EWEADN S7",
      displayname: "S7",
      deviceId: "s7",
      sensor: "3395",
      solutionRovider: "freq",

      uniqueNumber: "20",
      usage: 0x0010,
      usagePage: 0xff01,
      maxReportRateHz: 1000,
      reportRateSwitchable: false,
      isSupported: true,
    },
    {
      vendorId: 0xa8a5,
      productId: 0x2255,
      productName: "EWEADN S7",
      displayname: "S7",
      deviceId: "s7",
      sensor: "3395",
      solutionRovider: "freq",

      uniqueNumber: "20-1",
      usage: 0x0010,
      usagePage: 0xff01,
      maxReportRateHz: 1000,
      reportRateSwitchable: true,
      isSupported: true,
    },
    {
      vendorId: 0xa8a4,
      productId: 0x2255,
      productName: "S7 Plus",
      displayname: "S7 Plus",
      deviceId: "s7plus",
      sensor: "3311A",
      solutionRovider: "freq",
      uniqueNumber: "26",
      freqLinkHint: "c",
      usage: 0x0010,
      usagePage: 0xff01,
      maxReportRateHz: 1000,
      reportRateSwitchable: false,
      isSupported: true,
    },
    {
      vendorId: 0xa8a5,
      productId: 0x2255,
      productName: "S7 Plus",
      displayname: "S7 Plus",
      deviceId: "s7plus",
      sensor: "3311A",
      solutionRovider: "freq",
      uniqueNumber: "26-1",
      freqLinkHint: "c",
      usage: 0x0010,
      usagePage: 0xff01,
      maxReportRateHz: 1000,
      reportRateSwitchable: true,
      isSupported: true,
    },
    {
      vendorId: 0xa8a5,
      productId: 0x2255,
      productName: "EWEADN S7SE",
      displayname: "S7 SE",
      deviceId: "s7se",
      sensor: "3311a",
      solutionRovider: "freq",

      uniqueNumber: "21-1",
      usage: 0x0010,
      usagePage: 0xff01,
      maxReportRateHz: 1000,
      reportRateSwitchable: true,
      isSupported: true,
    },
    {
      vendorId: 0xa8a4,
      productId: 0x2255,
      productName: "EWEADN S7SE",
      displayname: "S7 SE",
      deviceId: "s7sea",
      sensor: "3311",
      solutionRovider: "freq",

      uniqueNumber: "21",
      usage: 0x0010,
      usagePage: 0xff01,
      maxReportRateHz: 1000,
      reportRateSwitchable: false,
      isSupported: true,
    },
    {
      vendorId: 0xa8a4,
      productId: 0x2255,
      productName: "EWEADN S9SE",
      displayname: "S9 SE",
      deviceId: "s9se",
      sensor: "3311A",
      solutionRovider: "freq",

      uniqueNumber: "5",
      freqLinkHint: "c",
      usage: 0x0010,
      usagePage: 0xff01,
      maxReportRateHz: 1000,
      reportRateSwitchable: false,
      isSupported: true,
    },
    {
      vendorId: 0xa8a5,
      productId: 0x2255,
      productName: "EWEADN S9SE",
      displayname: "S9 SE",
      deviceId: "s9se",
      sensor: "3311A",
      solutionRovider: "freq",

      uniqueNumber: "5-1",
      freqLinkHint: "c",
      usage: 0x0010,
      usagePage: 0xff01,
      maxReportRateHz: 1000,
      reportRateSwitchable: true,
      isSupported: true,
    },
    {
      vendorId: 0xa8a4,
      productId: 0x2255,
      productName: "EWEADN X23 carbon",
      displayname: "X23 Carbon",
      deviceId: "x23carbon",
      sensor: "3315",
      solutionRovider: "freq",

      uniqueNumber: "7",
      usage: 0x0010,
      usagePage: 0xff01,
      maxReportRateHz: 1000,
      reportRateSwitchable: false,
      isSupported: true,
    },
    {
      vendorId: 0xa8a5,
      productId: 0x2255,
      productName: "EWEADN X23 carbon",
      displayname: "X23 Carbon",
      deviceId: "x23carbon",
      sensor: "3315",
      solutionRovider: "freq",

      uniqueNumber: "7-2",
      usage: 0x0010,
      usagePage: 0xff01,
      maxReportRateHz: 1000,
      reportRateSwitchable: true,
      isSupported: true,
    },
    {
      vendorId: 0xa8a4,
      productId: 0x2255,
      productName: "EWEADN X23 carbon",
      displayname: "X23 Carbon",
      deviceId: "x23carbon2",
      sensor: "3315",
      solutionRovider: "freq",

      uniqueNumber: "7",
      freqLinkHint: "c",
      usage: 0x0010,
      usagePage: 0xff01,
      maxReportRateHz: 1000,
      reportRateSwitchable: false,
      isSupported: true,
    },
    {
      vendorId: 0xa8a5,
      productId: 0x2255,
      productName: "EWEADN X23 carbon",
      displayname: "X23 Carbon",
      deviceId: "x23carbon2",
      sensor: "3315",
      solutionRovider: "freq",

      uniqueNumber: "7-2",
      freqLinkHint: "c",
      usage: 0x0010,
      usagePage: 0xff01,
      maxReportRateHz: 1000,
      reportRateSwitchable: true,
      isSupported: true,
    },
    {
      vendorId: 0xa8a4,
      productId: 0x2255,
      productName: "EWEADN X23Max",
      displayname: "X23 Max",
      deviceId: "x23max",
      sensor: "3395",
      solutionRovider: "freq",

      uniqueNumber: "3",
      usage: 0x0010,
      usagePage: 0xff01,
      maxReportRateHz: 1000,
      reportRateSwitchable: true,
      isSupported: true,
    },
    {
      vendorId: 0xa8a5,
      productId: 0x2255,
      productName: "EWEADN X23Max",
      displayname: "X23 Max",
      deviceId: "x23max",
      sensor: "3395",
      solutionRovider: "freq",

      uniqueNumber: "3-1",
      usage: 0x0010,
      usagePage: 0xff01,
      maxReportRateHz: 1000,
      reportRateSwitchable: true,
      isSupported: true,
    },
    {
      vendorId: 0xa8a4,
      productId: 0x2255,
      productName: "EWEADN X23SE",
      displayname: "X23 SE",
      deviceId: "x23se",
      sensor: "3311",
      solutionRovider: "freq",

      uniqueNumber: "4",
      usage: 0x0010,
      usagePage: 0xff01,
      maxReportRateHz: 1000,
      reportRateSwitchable: true,
      isSupported: true,
    },
    {
      vendorId: 0xa8a5,
      productId: 0x2255,
      productName: "EWEADN X23SE",
      displayname: "X23 SE",
      deviceId: "x23se",
      sensor: "3311",
      solutionRovider: "freq",

      uniqueNumber: "4-1",
      usage: 0x0010,
      usagePage: 0xff01,
      maxReportRateHz: 1000,
      reportRateSwitchable: true,
      isSupported: true,
    },
    {
      vendorId: 0xa8a4,
      productId: 0x2255,
      productName: "EWEADN X23",
      displayname: "X23 星闪",
      deviceId: "x23",
      sensor: "3311",
      solutionRovider: "freq",

      uniqueNumber: "2",
      usage: 0x0010,
      usagePage: 0xff01,
      maxReportRateHz: 1000,
      reportRateSwitchable: false,
      isSupported: true,
    },
    {
      vendorId: 0xa8a5,
      productId: 0x2255,
      productName: "EWEADN X23",
      displayname: "X23 星闪",
      deviceId: "x23",
      sensor: "3311",
      solutionRovider: "freq",

      uniqueNumber: "2-1",
      usage: 0x0010,
      usagePage: 0xff01,
      maxReportRateHz: 1000,
      reportRateSwitchable: true,
      isSupported: true,
    },
    {
      vendorId: 0xa8a4,
      productId: 0x2255,
      productName: "EWEADN X23L carbon",
      displayname: "X23L Carbon",
      deviceId: "x23lcarbon",
      sensor: "3315",
      solutionRovider: "freq",

      uniqueNumber: "8",
      usage: 0x0010,
      usagePage: 0xff01,
      maxReportRateHz: 1000,
      reportRateSwitchable: false,
      isSupported: true,
    },
    {
      vendorId: 0xa8a5,
      productId: 0x2255,
      productName: "EWEADN X23L carbon",
      displayname: "X23L Carbon",
      deviceId: "x23lcarbon",
      sensor: "3315",
      solutionRovider: "freq",

      uniqueNumber: "8-1",
      usage: 0x0010,
      usagePage: 0xff01,
      maxReportRateHz: 1000,
      reportRateSwitchable: true,
      isSupported: true,
    },
    {
      vendorId: 0xa8a4,
      productId: 0x2255,
      productName: "EWEADN X23Pro",
      displayname: "X23Pro",
      deviceId: "x23pro2",
      sensor: "3315",
      solutionRovider: "freq",

      uniqueNumber: "1",
      freqLinkHint: "c",
      usage: 0x0010,
      usagePage: 0xff01,
      maxReportRateHz: 1000,
      reportRateSwitchable: false,
      isSupported: true,
    },
    {
      vendorId: 0xa8a5,
      productId: 0x2255,
      productName: "EWEADN X23Pro",
      displayname: "X23Pro",
      deviceId: "x23pro2",
      sensor: "3315",
      solutionRovider: "freq",

      uniqueNumber: "1-1",
      freqLinkHint: "c",
      usage: 0x0010,
      usagePage: 0xff01,
      maxReportRateHz: 1000,
      reportRateSwitchable: true,
      isSupported: true,
    },
    {
      vendorId: 0xa8a4,
      productId: 0x2255,
      productName: "EWEADN X23 Pro",
      displayname: "X23Pro",
      deviceId: "x23pro3",
      sensor: "3311",
      solutionRovider: "freq",
      freqLinkHint: "c",
      usage: 0x0010,
      usagePage: 0xff01,
      maxReportRateHz: 1000,
      reportRateSwitchable: false,
      isSupported: true,
    },
    {
      vendorId: 0xa8a5,
      productId: 0x2255,
      productName: "EWEADN X23 Pro",
      displayname: "X23Pro",
      deviceId: "x23pro3",
      sensor: "3311",
      solutionRovider: "freq",
      freqLinkHint: "c",
      usage: 0x0010,
      usagePage: 0xff01,
      maxReportRateHz: 1000,
      reportRateSwitchable: true,
      isSupported: true,
    },
    {
      vendorId: 0xa8a4,
      productId: 0x2255,
      productName: "EWEADN X23SE",
      displayname: "X23SE",
      deviceId: "x23se2",
      sensor: "8925",
      solutionRovider: "freq",

      uniqueNumber: "6",
      freqLinkHint: "c",
      usage: 0x0010,
      usagePage: 0xff01,
      maxReportRateHz: 1000,
      reportRateSwitchable: false,
      isSupported: true,
    },
    {
      vendorId: 0xa8a5,
      productId: 0x2255,
      productName: "EWEADN X23SE",
      displayname: "X23SE",
      deviceId: "x23se2",
      sensor: "8925",
      solutionRovider: "freq",

      uniqueNumber: "6-1",
      freqLinkHint: "c",
      usage: 0x0010,
      usagePage: 0xff01,
      maxReportRateHz: 1000,
      reportRateSwitchable: true,
      isSupported: true,
    },
    {
      vendorId: 0xa8a4,
      productId: 0x2255,
      productName: "EWEADN E7 V2",
      displayname: "E7 V2",
      deviceId: "e7v2",
      is4G: false,
      solutionRovider: "freqC",

      uniqueNumber: "2",
      isSupported: true,
      url: "https://eweadn1.yjx2012.com/",
    },
    {
      vendorId: 0xa8a5,
      productId: 0x2255,
      productName: "EWEADN E7 V2",
      displayname: "E7 V2",
      deviceId: "e7v2",
      is4G: true,
      solutionRovider: "freqC",

      uniqueNumber: "2-1",
      isSupported: true,
      url: "https://eweadn1.yjx2012.com/",
    },
    {
      vendorId: 0xb6a4,
      productId: 0x40c0,
      productName: "EWEADN E7 V2 MAX",
      displayname: "E7 V2 Max",
      deviceId: "e7v2Max",
      is4G: false,
      solutionRovider: "yxt",
      manufacturerName: "YXT",
      maxReportRateHz: 8000,
      /** 公版滑条上限 30000，对齐 3395 档 */
      sensor: "3395",

      uniqueNumber: "3",
      isSupported: true,
    },
    {
      vendorId: 0xb6a4,
      productId: 0x40c1,
      productName: "EWEADN E7 V2 MAX_2.4G",
      displayname: "E7 V2 Max",
      deviceId: "e7v2Max",
      is4G: true,
      solutionRovider: "yxt",
      manufacturerName: "YXT",
      maxReportRateHz: 8000,
      sensor: "3395",

      uniqueNumber: "3-1",
      isSupported: true,
    },
    {
      vendorId: 0xa8a4,
      productId: 0x2255,
      productName: "EWEADN GS02 Pro",
      displayname: "GS02 Pro",
      deviceId: "gs02Pro",
      is4G: false,
      solutionRovider: "freqC",

      uniqueNumber: "1",
      isSupported: true,
      url: "https://eweadn1.yjx2012.com/",
    },
    {
      vendorId: 0xa8a5,
      productId: 0x2255,
      productName: "EWEADN GS02 Pro",
      displayname: "GS02 Pro",
      deviceId: "gs02Pro",
      is4G: true,
      solutionRovider: "freqC",

      uniqueNumber: "1-1",
      isSupported: true,
      url: "https://eweadn1.yjx2012.com/",
    },
    {
      vendorId: 0x3554,
      productId: 0xfb36,
      customerId: 41,
      moudleId: 19,
      type: 3,
      productName: "EWEADN A8 WB Ultra",
      displayname: "A8 WB Ultra",
      deviceId: "a8wbultra",
      sensor: "3955",
      solutionRovider: "jiangmeng",

      uniqueNumber: "11",
      isSupported: true,
    },
    {
      vendorId: 0x3554,
      productId: 0xfb35,
      customerId: 41,
      moudleId: 19,
      type: 5,
      productName: "EWEADN A8 WB Ultra",
      displayname: "A8 WB Ultra",
      deviceId: "a8wbultra",
      sensor: "3955",
      solutionRovider: "jiangmeng",

      uniqueNumber: "11-2",
      isSupported: true,
    },
    {
      vendorId: 0x3554,
      productId: 0xfb36,
      customerId: 41,
      moudleId: 20,
      type: 3,
      productName: "EWEADN A8 WB Ultra",
      displayname: "A8 WB Ultra",
      deviceId: "a8wbultra",
      sensor: "3955",
      solutionRovider: "jiangmeng",

      uniqueNumber: "11",
      isSupported: true,
    },
    {
      vendorId: 0x3554,
      productId: 0xfb35,
      customerId: 41,
      moudleId: 20,
      type: 5,
      productName: "EWEADN A8 WB Ultra",
      displayname: "A8 WB Ultra",
      deviceId: "a8wbultra",
      sensor: "3955",
      solutionRovider: "jiangmeng",

      uniqueNumber: "11-2",
      isSupported: true,
    },
    {
      vendorId: 0x3554,
      productId: 0xfb5e,
      customerId: 41,
      moudleId: 24,
      type: 3,
      productName: "EXX Alpha6",
      displayname: "Alpha6",
      deviceId: "alpha6",
      sensor: "3955",
      solutionRovider: "jiangmeng",
      uniqueNumber: "17",
      magneticMicroswitch: true,
      noDongleLight: true,
      brand: "EXX",
      isSupported: true,
    },
    {
      vendorId: 0x3554,
      productId: 0xfb5f,
      customerId: 41,
      moudleId: 24,
      type: 5,
      productName: "EXX Alpha6",
      displayname: "Alpha6",
      deviceId: "alpha6",
      sensor: "3955",
      solutionRovider: "jiangmeng",
      uniqueNumber: "17-1",
      magneticMicroswitch: true,
      noDongleLight: true,
      brand: "EXX",
      isSupported: true,
    },
    {
      vendorId: 0x3554,
      productId: 0xf515,
      customerId: 41,
      moudleId: 11,
      type: 3,
      productName: "EWEADN S9Pro V2",
      displayname: "S9 Pro v2",
      deviceId: "s9prov2",
      sensor: "3395",
      solutionRovider: "jiangmeng",

      uniqueNumber: "1",
      isSupported: true,
    },
    {
      vendorId: 0x3554,
      productId: 0xf517,
      customerId: 41,
      moudleId: 11,
      type: 5,
      productName: "EWEADN 8K",
      displayname: "S9 Pro v2",
      deviceId: "s9prov2",
      sensor: "3395",
      solutionRovider: "jiangmeng",

      uniqueNumber: "1-1",
      isSupported: true,
    },
    {
      vendorId: 0x3554,
      productId: 0xfb47,
      customerId: 41,
      moudleId: 3,
      type: 3,
      productName: "EWEADN S9Ultimate",
      displayname: "S9 Ultimate",
      deviceId: "s9ultimate",
      sensor: "3950",
      solutionRovider: "jiangmeng",

      uniqueNumber: "9",
      noDongleLight: true,
      isSupported: true,
    },
    {
      vendorId: 0x3554,
      productId: 0xfb45,
      customerId: 41,
      moudleId: 3,
      type: 0,
      productName: "EWEADN S9Ultimate",
      displayname: "S9 Ultimate",
      deviceId: "s9ultimate",
      sensor: "3950",
      solutionRovider: "jiangmeng",

      uniqueNumber: "9-1",
      noDongleLight: true,
      isSupported: true,
    },
    {
      vendorId: 0x3554,
      productId: 0xfb48,
      customerId: 41,
      moudleId: 3,
      type: 5,
      productName: "EWEADN S9Ultimate",
      displayname: "S9 Ultimate",
      deviceId: "s9ultimate",
      sensor: "3950",
      solutionRovider: "jiangmeng",

      uniqueNumber: "9-2",
      noDongleLight: true,
      isSupported: true,
    },
    {
      vendorId: 0x3554,
      productId: 0xf515,
      customerId: 41,
      moudleId: 10,
      type: 3,
      productName: "EWEADN S9Ultra V2",
      displayname: "S9 Ultra v2",
      deviceId: "s9ultrav2",
      sensor: "3950",
      solutionRovider: "jiangmeng",

      uniqueNumber: "4",
      isSupported: true,
    },
    {
      vendorId: 0x3554,
      productId: 0xf517,
      customerId: 41,
      moudleId: 10,
      type: 5,
      productName: "EWEADN 8K",
      displayname: "S9 Ultra v2",
      deviceId: "s9ultrav2",
      sensor: "3950",
      solutionRovider: "jiangmeng",

      uniqueNumber: "4-1",
      isSupported: true,
    },
    {
      vendorId: 0x3554,
      productId: 0xfb36,
      customerId: 41,
      moudleId: 15,
      type: 3,
      productName: "EWEADN S9Max",
      displayname: "S9Max",
      deviceId: "s9max2",
      sensor: "3395",
      solutionRovider: "jiangmeng",

      uniqueNumber: "6",
      noDongleLight: true,
    },
    {
      vendorId: 0x3554,
      productId: 0xfb35,
      customerId: 41,
      moudleId: 15,
      type: 5,
      productName: "EWEADN 8K Nano",
      displayname: "S9Max",
      deviceId: "s9max2",
      sensor: "3395",
      solutionRovider: "jiangmeng",

      uniqueNumber: "6-1",
      noDongleLight: true,
    },
    {
      vendorId: 0x3554,
      productId: 0xf515,
      customerId: 41,
      moudleId: 17,
      type: 3,
      productName: "EWEADN S9V2 Master",
      displayname: "S9V2 Master",
      deviceId: "s9v2master",
      sensor: "3955",
      solutionRovider: "jiangmeng",

      uniqueNumber: "8",
      isSupported: true,
    },
    {
      vendorId: 0x3554,
      productId: 0xf517,
      customerId: 41,
      moudleId: 17,
      type: 5,
      productName: "EWEADN 8K",
      displayname: "S9V2 Master",
      deviceId: "s9v2master",
      sensor: "3955",
      solutionRovider: "jiangmeng",

      uniqueNumber: "8-1",
      isSupported: true,
      demoEnable: true,
    },
    {
      vendorId: 0x3554,
      productId: 0xf515,
      customerId: 41,
      moudleId: 18,
      type: 3,
      productName: "EWEADN S9V2 Master+",
      displayname: "S9V2 Master+",
      deviceId: "s9v2master+",
      sensor: "3955",
      solutionRovider: "jiangmeng",

      uniqueNumber: "10",
      magneticMicroswitch: true,
      magneticMicroswitchWirelessTrigger: false,
      isSupported: true,
    },
    {
      vendorId: 0x3554,
      productId: 0xf517,
      customerId: 41,
      moudleId: 18,
      type: 5,
      productName: "EWEADN 8K",
      displayname: "S9V2 Master+",
      deviceId: "s9v2master+",
      sensor: "3955",
      solutionRovider: "jiangmeng",

      uniqueNumber: "10-1",
      magneticMicroswitch: true,
      magneticMicroswitchWirelessTrigger: false,
      isSupported: true,
    },
    {
      vendorId: 0x3554,
      productId: 0xfb36,
      customerId: 41,
      moudleId: 23,
      type: 3,
      productName: "EWEADN S9V2 Turbo",
      displayname: "S9V2 Turbo",
      deviceId: "s9v2turbo",
      sensor: "3950",
      solutionRovider: "jiangmeng",

      uniqueNumber: "13",
      noDongleLight: true,
      isSupported: true,
    },
    {
      vendorId: 0x3554,
      productId: 0xfb35,
      customerId: 41,
      moudleId: 23,
      type: 5,
      productName: "EWEADN 8K Nano",
      displayname: "S9V2 Turbo",
      deviceId: "s9v2turbo",
      sensor: "3950",
      solutionRovider: "jiangmeng",

      uniqueNumber: "13-1",
      noDongleLight: true,
      isSupported: true,
    },
    {
      vendorId: 0x3554,
      productId: 0xf515,
      customerId: 41,
      moudleId: 22,
      type: 3,
      productName: "EWEADN S9V2 Ultimate",
      displayname: "S9V2 Ultimate",
      deviceId: "s9v2ultimate",
      sensor: "3955",
      solutionRovider: "jiangmeng",

      uniqueNumber: "12",
      noDongleLight: true,
      isSupported: true,
    },
    {
      vendorId: 0x3554,
      productId: 0xf517,
      customerId: 41,
      moudleId: 22,
      type: 5,
      productName: "EWEADN 8K",
      displayname: "S9V2 Ultimate",
      deviceId: "s9v2ultimate",
      sensor: "3955",
      solutionRovider: "jiangmeng",

      uniqueNumber: "12-1",
      noDongleLight: true,
      isSupported: true,
    },
    {
      vendorId: 0x3554,
      productId: 0xf5a0,
      customerId: 41,
      moudleId: 2,
      type: 3,
      productName: "EWEADN X23 Max",
      displayname: "X23 Max",
      deviceId: "x23max",
      sensor: "3395",
      solutionRovider: "jiangmeng",
      uniqueNumber: "14",
      isSupported: true,
      link: {
        vendor: "jm",
        channel: "web",
        action: "connect",
        queryMode: "auto",
        presetQuery: { cid: 41, mid: 2 },
      },
    },
    {
      vendorId: 0x3554,
      productId: 0xf59f,
      customerId: 41,
      moudleId: 4,
      type: 5,
      productName: "EWEADN X23 Max",
      displayname: "X23 Max",
      deviceId: "x23max",
      sensor: "3395",
      solutionRovider: "jiangmeng",
      uniqueNumber: "14-1",
      isSupported: true,
      link: {
        vendor: "jm",
        channel: "web",
        action: "connect",
        queryMode: "auto",
        presetQuery: { cid: 41, mid: 4 },
      },
    },
    {
      vendorId: 0x3554,
      productId: 0xf5b2,
      customerId: 41,
      moudleId: 4,
      type: 5,
      productName: "EWEADN X23 Max",
      displayname: "X23 Max",
      deviceId: "x23max",
      sensor: "3395",
      solutionRovider: "jiangmeng",
      uniqueNumber: "15",
      isSupported: true,
      link: {
        vendor: "jm",
        channel: "web",
        action: "connect",
        queryMode: "auto",
        presetQuery: { cid: 41, mid: 4 },
      },
    },
    {
      vendorId: 0x3554,
      productId: 0xf5b3,
      customerId: 41,
      moudleId: 4,
      type: 3,
      productName: "EWEADN X23 Max",
      displayname: "X23 Max",
      deviceId: "x23max",
      sensor: "3395",
      solutionRovider: "jiangmeng",
      uniqueNumber: "16",
      isSupported: true,
      link: {
        vendor: "jm",
        channel: "web",
        action: "connect",
        queryMode: "auto",
        presetQuery: { cid: 41, mid: 4 },
      },
    },
    {
      vendorId: 0x3554,
      productId: 0xf5b5,
      customerId: 41,
      moudleId: 4,
      type: 5,
      productName: "EWEADN X23 Max",
      displayname: "X23 Max",
      deviceId: "x23max",
      sensor: "3395",
      solutionRovider: "jiangmeng",
      uniqueNumber: "16-1",
      isSupported: true,
      link: {
        vendor: "jm",
        channel: "web",
        action: "connect",
        queryMode: "auto",
        presetQuery: { cid: 41, mid: 4 },
      },
    },
    {
      vendorId: 0x3554,
      productId: 0xfb36,
      customerId: 41,
      moudleId: 13,
      type: 3,
      productName: "EWEADN X23 Zhuoyue",
      displayname: "X23 Zhuoyue",
      deviceId: "x23zhuoyue",
      sensor: "3395",
      solutionRovider: "jiangmeng",

      uniqueNumber: "5",
      noDongleLight: true, // 接收器无灯，灯效页不展示接收器 RGB
      isSupported: true,
    },
    {
      vendorId: 0x3554,
      productId: 0xfb35,
      customerId: 41,
      moudleId: 13,
      type: 5,
      productName: "EWEADN X23 Zhuoyue",
      displayname: "X23 Zhuoyue",
      deviceId: "x23zhuoyue",
      sensor: "3395",
      solutionRovider: "jiangmeng",

      uniqueNumber: "5-1",
      noDongleLight: true,
      isSupported: true,
    },
    {
      vendorId: 0x3554,
      productId: 0xf515,
      customerId: 41,
      moudleId: 8,
      type: 3,
      productName: "EWEADN Z7",
      displayname: "Z7",
      deviceId: "z7",
      sensor: "3950",
      solutionRovider: "jiangmeng",

      uniqueNumber: "3",
      isSupported: true,
    },
    {
      vendorId: 0x3554,
      productId: 0xf517,
      customerId: 41,
      moudleId: 8,
      type: 5,
      productName: "EWEADN 8K",
      displayname: "Z7",
      deviceId: "z7",
      sensor: "3950",
      solutionRovider: "jiangmeng",

      uniqueNumber: "3-1",
      isSupported: true,
    },
    {
      vendorId: 0x3554,
      productId: 0xf515,
      customerId: 41,
      moudleId: 16,
      type: 3,
      productName: "EWEADN Z7Master",
      displayname: "Z7 Master",
      deviceId: "z7master",
      sensor: "3955",
      solutionRovider: "jiangmeng",

      uniqueNumber: "7",
      isSupported: true,
    },
    {
      vendorId: 0x3554,
      productId: 0xf517,
      customerId: 41,
      moudleId: 16,
      type: 5,
      productName: "EWEADN 8K",
      displayname: "Z7 Master",
      deviceId: "z7master",
      sensor: "3955",
      solutionRovider: "jiangmeng",

      uniqueNumber: "7-1",
      isSupported: true,
    },
    {
      vendorId: 0x088d,
      productId: 0x062e,
      productName: "EWEADN S9",
      displayname: "S9",
      deviceId: "s9",
      is4G: false,
      solutionRovider: "lanyi",

      uniqueNumber: "1",
      isSupported: true,
      url: "https://hub.eweadn.cn/#/",
    },
    {
      vendorId: 0x089d,
      productId: 0x062f,
      productName: "Wireless-Receiver",
      displayname: "S9",
      deviceId: "s9",
      is4G: true,
      solutionRovider: "lanyi",

      uniqueNumber: "1-1",
      isSupported: true,
      url: "https://hub.eweadn.cn/#/",
    },
    {
      vendorId: 0xb6a4,
      productId: 0x4090,
      productName: "EWEADN G2 SE USB",
      displayname: "G2 SE",
      deviceId: "g2se",
      is4G: false,
      solutionRovider: "qh",
      uniqueNumber: "1",
      isSupported: true,
      link: {
        vendor: "qh",
        channel: "web",
        action: "connect",
        queryMode: "auto",
      },
    },
    {
      vendorId: 0xb6a4,
      productId: 0x4091,
      productName: "EWEADN G2 SE 2.4G",
      displayname: "G2 SE",
      deviceId: "g2se",
      is4G: true,
      solutionRovider: "qh",
      uniqueNumber: "2",
      isSupported: true,
      link: {
        vendor: "qh",
        channel: "web",
        action: "connect",
        queryMode: "auto",
      },
    },
    {
      vendorId: 0x04f3,
      productId: 0x026e,
      productName: "EWEADN X23 Pro",
      displayname: "X23 Pro",
      deviceId: "x23pro",
      is4G: false,
      solutionRovider: "yuandaxin",

      uniqueNumber: "1",
      isSupported: true,
      url: "https://hub.eweadn.cn/#/",
    },
    {
      vendorId: 0x04f3,
      productId: 0x026f,
      productName: "EWEADN X23 Pro",
      displayname: "X23 Pro",
      deviceId: "x23pro",
      is4G: true,
      solutionRovider: "yuandaxin",

      uniqueNumber: "1-1",
      isSupported: true,
      url: "https://hub.eweadn.cn/#/",
    },
    {
      vendorId: 0x1209,
      productId: 0x3a87,
      productName: "EXX Alpha7",
      displayname: "Alpha7",
      deviceId: "alpha7",
      sensor: "3955A",
      is4G: false,
      solutionRovider: "zhanli",

      uniqueNumber: "2",
      usage: 0x0010,
      usagePage: 0xff01,
      brand: "EXX",
      isSupported: true,
      noDongleLight: true,
      demoEnable: true,
    },
    {
      vendorId: 0x1209,
      productId: 0x3a88,
      productName: "EXX Alpha7",
      displayname: "Alpha7",
      deviceId: "alpha7",
      sensor: "3955A",
      is4G: true,
      solutionRovider: "zhanli",

      uniqueNumber: "2-2",
      usage: 0x0010,
      usagePage: 0xff01,
      brand: "EXX",
      isSupported: true,
    },
    {
      vendorId: 0x1209,
      productId: 0x3a88,
      productName: "EXX 8K Dongle",
      displayname: "Alpha7",
      deviceId: "alpha7",
      sensor: "3955A",
      is4G: true,
      solutionRovider: "zhanli",

      uniqueNumber: "2-2",
      usage: 0x0010,
      usagePage: 0xff01,
      brand: "EXX",
      isSupported: true,
    },
    {
      vendorId: 0x1209,
      productId: 0x5a86,
      productName: "EWEADN Z7Max",
      displayname: "Z7 Max",
      deviceId: "z7max",
      sensor: "3955A",
      is4G: false,
      solutionRovider: "zhanli",

      uniqueNumber: "1",
      usage: 0x0010,
      usagePage: 0xff01,
      isSupported: true,
      noDongleLight: true,
    },
    {
      vendorId: 0x1209,
      productId: 0x5a87,
      productName: "EWEADN 8K",
      displayname: "Z7 Max",
      deviceId: "z7max",
      sensor: "3955A",
      is4G: true,
      solutionRovider: "zhanli",

      uniqueNumber: "1-1",
      usage: 0x0010,
      usagePage: 0xff01,
      isSupported: true,
    },
    {
      vendorId: 0xa700,
      productId: 0x8316,
      productName: "EWEADN E11V2",
      displayname: "E11 V2",
      deviceId: "e11v2",
      is4G: false,
      solutionRovider: "xichen",
      isSupported: true,
      skipColorConfig: true,
      url: "https://eweadn-e11v2.xcgaming.net/",
    },
    {
      vendorId: 0xa700,
      productId: 0x8315,
      productName: "EWEADN E11V2",
      displayname: "E11 V2",
      deviceId: "e11v2",
      is4G: true,
      solutionRovider: "xichen",
      isSupported: true,
      skipColorConfig: true,
      url: "https://eweadn-e11v2.xcgaming.net/",
    },
  ],
  earphone: [
    {
      vendorId: 0x0d8c,
      productId: 0x0381,
      productName: "EWEADN-VX01 Dongle",
      displayname: "VX01",
      deviceId: "vx01",
      solutionRovider: "cmedia",

      uniqueNumber: "1",
      protocol: "xear",
      isSupported: true,
      skipColorConfig: true,
      communitySupported: false,
      /** 控音依赖桌面端 CmXearSDK，网页端 Mock 无效 */
      desktopOnly: true,
    },
    {
      vendorId: 0x0d8c,
      productId: 0x0382,
      productName: "EWEADN-VX01S Dongle",
      displayname: "VX01S",
      deviceId: "vx01s",
      solutionRovider: "cmedia",

      uniqueNumber: "2",
      protocol: "xear",
      isSupported: true,
      skipColorConfig: true,
      communitySupported: false,
      /** 控音依赖桌面端 CmXearSDK，网页端 Mock 无效 */
      desktopOnly: true,
    },
    {
      vendorId: 0x0d8c,
      productId: 0x0380,
      productName: "EWEADN-VX02",
      displayname: "VX02",
      deviceId: "vx02",
      workMode: "2",
      solutionRovider: "cmedia",

      uniqueNumber: "3",
      protocol: "xear",
      isSupported: true,
      skipColorConfig: true,
      communitySupported: false,
      /** 控音依赖桌面端 CmXearSDK + VX02 驱动/APO，网页端 Mock 无效 */
      desktopOnly: true,
    },
    {
      vendorId: 0x3302,
      productId: 0x13b6,
      productName: "MACHENIKE HX50",
      displayname: "HG50",
      deviceId: "thunderobot-hg50",
      solutionRovider: "ttgk",

      uniqueNumber: "1",
      protocol: "cb-hid",
      isSupported: true,
      communitySupported: false,
    },
    {
      vendorId: 0x3302,
      productId: 0x2326,
      productName: "EWEADN-VX07",
      displayname: "VX07",
      deviceId: "eweadn-vx07",
      solutionRovider: "ttgk",

      uniqueNumber: "2",
      protocol: "cb-hid",
      chipFamily: "kt",
      isSupported: true,
      communitySupported: false,
      // demoEnable: true, // 演示模式暂未开放
      // 预设壁纸授权商 ID: 洛天依
      licensorId: 1,
    },
    {
      vendorId: 0x3206,
      productId: 0x0881,
      productName: "EWEADN-VX20 Headset",
      displayname: "VX20",
      deviceId: "vx20",
      solutionRovider: "bbh",
      uniqueNumber: "1",
      protocol: "bbh-cdc",
      isSupported: true,
      skipColorConfig: true,
      communitySupported: false,
      /** 控音：USB-CDC + 系统音频端点；仅桌面 Hub */
      desktopOnly: true,
    },
    {
      vendorId: 0x3206,
      productId: 0x0861,
      productName: "EWEADN-VX20 Dongle",
      displayname: "VX20",
      deviceId: "vx20",
      solutionRovider: "bbh",
      uniqueNumber: "2",
      protocol: "bbh-cdc",
      isSupported: true,
      skipColorConfig: true,
      communitySupported: false,
      /** 控音：USB-CDC + 系统音频端点；仅桌面 Hub */
      desktopOnly: true,
    },
  ],
};
